import React, { useState, useEffect, useMemo } from "react";
import {
  Grid,
  Divider,
  TextField,
  Typography,
  Button,
  FormControl,
  MenuItem,
  makeStyles,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Paper,
  Switch,
  withStyles,
  CircularProgress,
  IconButton,
  Select,
  Radio,
  FormHelperText,
} from "@material-ui/core";
import Autocomplete from "@material-ui/lab/Autocomplete";
import ArrowForwardIosIcon from "@material-ui/icons/ArrowForwardIos";
import { Check } from "@material-ui/icons";
import SaveOutlinedIcon from "@material-ui/icons/SaveOutlined";
import CloseIcon from "@material-ui/icons/Close";
import EditIcon from "@material-ui/icons/Edit";
import DeleteOutlineIcon from "@material-ui/icons/DeleteOutline";
import ArrowBackIosIcon from "@material-ui/icons/ArrowBackIos";
import { inputFieldStyles, commonInlineStyles } from "../../styles";
import axios from "axios";
import { appUrl } from "../../../../../../../utils/config";
import { useApiBaseUrl } from "../../../CommonMethods/CommonMethods";
// BCM-881: the CMO Inventory Mapping table, below CMO Level Configurations.
import CmoInventoryMapping from "../../CmoInventoryMapping";
import { useLocation } from "react-router-dom";
import ProductTypePdfConfigTable, {
  allocationPdfTitle,
} from "../../ProductTypePdfConfigTable";
const useStyles = makeStyles((theme) => ({
  formTitle: {
    marginBottom: theme.spacing(4),
    fontWeight: 700,
    fontSize: 32,
    position: "relative",
  },
  formField: {
    width: "100%",
    marginBottom: 0,
    "& .MuiOutlinedInput-root": {
      backgroundColor: "#fff",
    },
  },
  button: {
    minWidth: 180,
    // fontWeight: 600,
    // fontSize: 16,
    borderRadius: 30,
    // height: 44,
  },
  backButton: {
    minWidth: 180,
    // fontWeight: 600,
    // fontSize: 16,
    borderRadius: 30,
    // height: 44,
    background: "#707070",
    color: "#fff",
    marginRight: theme.spacing(2),
  },
  table: {
    minWidth: 1200,
    marginTop: theme.spacing(2),
    marginBottom: theme.spacing(2),
    "& td, & th": {
      borderRight: "1px solid #e0e0e0",
      padding: "12px 16px",
    },
    "& td:last-child, & th:last-child": {
      borderRight: "none",
    },
  },
  tableHead: {
    backgroundColor: "#f9f9fc",
  },
  tableCell: {
    fontSize: 16,
  },
  tabContentContainer: {
    minHeight: 200,
    maxWidth: 1200,
    marginTop: 20,
  },
  iosSwitch: {
    "& > *": {
      height: "22px !important",
    },
    "& .MuiSwitch-switchBase .MuiSwitch-track": {
      backgroundColor: "#c6c6c6 !important",
    },
    "& .MuiSwitch-switchBase": {
      left: "2px",
      top: "-1px",
    },
    "& .MuiSwitch-switchBase.Mui-checked": {
      left: "auto",
      right: "18px",
    },
    "& .MuiSwitch-switchBase.Mui-checked .MuiSwitch-track": {
      backgroundColor: "#1890ff !important",
    },
  },
  checkedSwitch: {
    position: "absolute",
    width: "16px !important",
    left: "12px",
    top: "-3px",
    color: "white",
  },
  editContainer: {
    display: "flex",
    alignItems: "center",
    justifyContent: "space-between",
    minHeight: "40px",
  },
  actionButtons: {
    display: "flex",
    flexDirection: "column",
    marginTop: 4,
  },
  loaderContainer: {
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    minHeight: 200,
  },
  mandatoryDropdown: {
    width: "100%",
    "& .MuiSelect-root": {
      fontSize: "14px",
      padding: "8px 12px",
      textAlign: "left",
    },
    "& .MuiOutlinedInput-notchedOutline": {
      borderColor: "#c0c0c0",
    },
  },
  noPaddingMultiline: {
    '& .MuiOutlinedInput-root': {
      padding: '0 !important',
    },
    '& .MuiOutlinedInput-input': {
      padding: '8.5px 14px !important',
    },
  },
  radioChecked: {
    color: "#ec6535 !important",
    "&.Mui-disabled": {
      color: "#ec6535 !important",
      "& svg": {
        color: "#ec6535 !important",
      },
    },
  },
  radioCheckedForecast: {
    color: "#ec6535 !important",
    "&.Mui-disabled": {
      opacity: 0.5,
      "& svg": {
        color: "#ec6535 !important",
      },
    },
  },
  disabled: {},
}));

const batchOptions = [
  "Yes, for batches with the same brand",
  "No, single batch only",
  "Yes, for batches with same and different brands",
];

const batchOptionToId = {
  "Yes, for batches with the same brand": 1,
  "No, single batch only": 2,
  "Yes, for batches with same and different brands": 3,
};

const IOSSwitch = withStyles((theme) => ({
  root: {
    width: 44,
    height: 22,
    padding: 0,
    margin: theme.spacing(1),
  },
  switchBase: {
    padding: 1,
    "& .MuiSwitch-track": {
      backgroundColor: "#c6c6c6 !important",
    },
    "&$checked": {
      transform: "translateX(16px)",
      color: theme.palette.common.white,
      "& + $track": {
        backgroundColor: "#1890ff !important",
        opacity: 1,
        border: "none",
      },
      "& .MuiSwitch-track": {
        backgroundColor: "#1890ff !important",
      },
    },
    "&$focusVisible $thumb": {
      color: "#52d869",
      border: "6px solid #fff",
    },
  },
  thumb: {
    width: 18,
    height: 18,
  },
  track: {
    borderRadius: 26 / 2,
    backgroundColor: "#c6c6c6",
    opacity: 1,
    transition: theme.transitions.create(["background-color", "border"]),
  },
  checked: {},
  focusVisible: {},
}))(({ classes, ...props }) => (
  <Switch
    focusVisibleClassName={classes.focusVisible}
    disableRipple
    disabled={props.disabled}
    classes={{
      root: classes.root,
      switchBase: classes.switchBase,
      thumb: classes.thumb,
      track: classes.track,
      checked: classes.checked,
    }}
    {...props}
  />
));

const DocumentTypes = ({
  documentTypesData,
  setdocumentTypesData,
  isDocLoading,
  readOnly,
}) => {
  const classes = useStyles();
  const API_BASE_URL = useApiBaseUrl(appUrl);

  const [editState, setEditState] = useState({});
  const [renameValues, setRenameValues] = useState({});
  const [errors, setErrors] = useState({});
  const [categories, setCategories] = useState([]);
  const [isCategoryLoading, setIsCategoryLoading] = useState(false);
  const location = useLocation();

  const token = localStorage.getItem("authToken");

  useEffect(() => {
    let isMounted = true;
    const productConfig = false; // Derive productConfig from existingCmoDetailsReadOnly

    const fetchCategories = async () => {
      if (!token) {
        console.error("No authentication token found");
        setCategories([]);
        setIsCategoryLoading(false);
        return;
      }
      try {
        setIsCategoryLoading(true);
        const response = await axios.get(
          `${API_BASE_URL}/fetchDocumentCategories/${productConfig}`
        );
        if (response.data.documentCategoryList && isMounted) {
          setCategories(response.data.documentCategoryList); // Map documentCategoryList to categories
        }
      } catch (error) {
        console.error(
          "Error fetching document categories:",
          error.response?.data || error.message
        );
        setCategories([]);
      } finally {
        if (isMounted) setIsCategoryLoading(false);
      }
    };
    fetchCategories();
    return () => {
      isMounted = false;
    };
  }, [API_BASE_URL, token]);

  const validateInput = (value) => {
    if (value.length > 255) {
      return "Maximum 255 characters allowed";
    }
    if (!/^[a-zA-Z0-9\s\-/()&]*$/.test(value)) {
      return "Only alphabets, numbers, spaces, hyphens (-), slashes (/), parentheses (), and ampersands (&) are allowed";
    }
    return "";
  };

  const handleEditClick = (id, currentValue) => {
    setEditState((prev) => ({ ...prev, [id]: true }));
    setRenameValues((prev) => ({
      ...prev,
      [id]: currentValue === "NA" ? "" : currentValue,
    }));
    setErrors((prev) => ({ ...prev, [id]: "" }));
  };

  const handleCancel = (id) => {
    setEditState((prev) => ({ ...prev, [id]: false }));
    setRenameValues((prev) => ({ ...prev, [id]: "" }));
    setErrors((prev) => ({ ...prev, [id]: "" }));
  };

  const handleToggle = (id, checked) => {
    const updated = documentTypesData.map((doc) =>
      doc.documentTypeID === id ? { ...doc, activated: checked } : doc
    );
    setdocumentTypesData(updated);
  };

  const handleSave = (id) => {
    const value = renameValues[id] || "";
    const validationError = validateInput(value);

    if (validationError) {
      setErrors((prev) => ({ ...prev, [id]: validationError }));
      return;
    }
    setdocumentTypesData((prev) =>
      prev.map((doc) =>
        doc.documentTypeID === id
          ? { ...doc, newDocumentTypeName: renameValues[id] || "" }
          : doc
      )
    );
    setEditState((prev) => ({ ...prev, [id]: false }));
    setErrors((prev) => ({ ...prev, [id]: "" }));
  };

  const handleMandatoryChange = (id, value) => {
    setdocumentTypesData((prev) =>
      prev.map((doc) =>
        doc.documentTypeID === id
          ? { ...doc, mandatoryInProcessWorkflow: value === "Yes" }
          : doc
      )
    );
  };

  if (isDocLoading) {
    return (
      <div className={classes.loaderContainer}>
        <CircularProgress color="primary" />
      </div>
    );
  }
  // const handleBooleanChange = (id, field, value) => {
  //   const updated = documentTypesData.map((doc) =>
  //     doc.documentTypeID === id ? { ...doc, [field]: value === 'Yes' } : doc
  //   );
  //   setdocumentTypesData(updated);
  // };

  if (!documentTypesData || documentTypesData.length === 0) {
    return <Typography>No document types available</Typography>;
  }
  return (
    <TableContainer component={Paper} className={classes.table}>
      <Table>
        <TableHead className={classes.tableHead}>
          <TableRow>
            <TableCell className={classes.tableCell}>Selection</TableCell>
            <TableCell className={classes.tableCell}>Document Type</TableCell>
            <TableCell className={classes.tableCell}>
              Renamed Document Type
            </TableCell>
            <TableCell className={classes.tableCell}>
              Document Type ID
            </TableCell>

            <TableCell className={classes.tableCell}>
              Document Category
            </TableCell>
            <TableCell className={classes.tableCell}>
              Mandatory In Process Workflow
            </TableCell>
            {/* <TableCell className={classes.tableCell}>Show in View Goods Receipt... Page</TableCell>
            <TableCell className={classes.tableCell}>Mandatory in Process Flow 1</TableCell>
            <TableCell className={classes.tableCell}>Mandatory in Process Rlow 4</TableCell> */}
          </TableRow>
        </TableHead>
        <TableBody>
          {documentTypesData.map((type) => (
            <TableRow key={type.documentTypeID}>
              <TableCell>
                <span style={{ position: "relative" }}>
                  <IOSSwitch
                    className={classes.iosSwitch}
                    color="primary"
                    checked={!!type.activated}
                    onChange={(e) =>
                      handleToggle(type.documentTypeID, e.target.checked)
                    }
                    disabled={readOnly}
                  />
                  {!!type.activated && (
                    <Check className={classes.checkedSwitch} />
                  )}
                </span>
              </TableCell>
              <TableCell>{type.documentTypeName}</TableCell>
              <TableCell>
                {editState[type.documentTypeID] ? (
                  <div style={{ display: "flex", flexDirection: "column" }}>
                    <div style={{ display: "flex", alignItems: "center" }}>
                      <TextField
                        size="small"
                        variant="outlined"
                        value={renameValues[type.documentTypeID]}
                        onChange={(e) => {
                          const filtered = e.target.value.replace(
                            /[^a-zA-Z0-9\s\-/()&]/g,
                            ""
                          );
                          setRenameValues((prev) => ({
                            ...prev,
                            [type.documentTypeID]: filtered,
                          }));
                          // Clear error when typing
                          if (errors[type.documentTypeID]) {
                            setErrors((prev) => ({
                              ...prev,
                              [type.documentTypeID]: "",
                            }));
                          }
                        }}
                        onBlur={(e) => {
                          const { value } = e.target;
                          // Trim leading and trailing spaces for string values
                          if (
                            typeof value === "string" &&
                            value.trim() !== value
                          ) {
                            const trimmedValue = value.trim();
                            setRenameValues((prev) => ({
                              ...prev,
                              [type.documentTypeID]: trimmedValue,
                            }));
                          }
                        }}
                        placeholder="Enter text here"
                        inputProps={{
                          style: { fontSize: "14px" },
                          maxLength: 255,
                        }}
                        style={{ marginRight: 4, width: "400px" }}
                        disabled={readOnly}
                        error={!!errors[type.documentTypeID]}
                      />
                      <div className={classes.actionButtons}>
                        <IconButton
                          size="small"
                          onClick={() => handleCancel(type.documentTypeID)}
                        >
                          <CloseIcon fontSize="small" />
                        </IconButton>
                        <IconButton
                          size="small"
                          onClick={() => handleSave(type.documentTypeID)}
                        >
                          <SaveOutlinedIcon fontSize="small" />
                        </IconButton>
                      </div>
                    </div>
                    {errors[type.documentTypeID] && (
                      <Typography
                        style={{ fontSize: "10px" }}
                        color="error"
                        variant="caption"
                      >
                        {errors[type.documentTypeID]}
                      </Typography>
                    )}
                  </div>
                ) : (
                  <div
                    className={classes.editContainer}
                    style={{ display: "flex", alignItems: "center" }}
                  >
                    <span style={{ marginRight: 8 }}>
                      {type.newDocumentTypeName &&
                      type.newDocumentTypeName !== "NA"
                        ? type.newDocumentTypeName
                        : ""}
                    </span>
                    {!readOnly && (
                      <IconButton
                        size="normal"
                        onClick={() =>
                          handleEditClick(
                            type.documentTypeID,
                            type.newDocumentTypeName
                          )
                        }
                      >
                        <EditIcon fontSize="small" color="primary" />
                      </IconButton>
                    )}
                  </div>
                )}
              </TableCell>
              <TableCell>{type.documentTypeID}</TableCell>

              <TableCell>{type.documentCategoryName || ""}</TableCell>
              <TableCell>
                <FormControl
                  variant="outlined"
                  size="small"
                  className={classes.mandatoryDropdown}
                >
                  <Select
                    value={type.mandatoryInProcessWorkflow ? "Yes" : "No"}
                    onChange={(e) =>
                      handleMandatoryChange(type.documentTypeID, e.target.value)
                    }
                    disabled={readOnly}
                    displayEmpty
                  >
                    <MenuItem value="No">No</MenuItem>
                    <MenuItem value="Yes">Yes</MenuItem>
                  </Select>
                </FormControl>
              </TableCell>

              {/* <TableCell align="center">
  {categories.find((cat) => cat.documentCategoryID === type.documentCategoryID)?.documentCategoryName || 'NA'}
</TableCell> */}

              {/* <TableCell>
  <Select
    value={type.showInViewGoodsReceipt ? 'Yes' : 'No'}
    onChange={(e) =>
      handleBooleanChange(type.documentTypeID, 'showInViewGoodsReceipt', e.target.value)
    }
    disabled={readOnly}
    style={{ minWidth: 100 }}
  >
    <MenuItem value="Yes">Yes</MenuItem>
    <MenuItem value="No">No</MenuItem>
  </Select>
</TableCell>
<TableCell>
  <Select
    value={type.mandatoryInProcessFlow1 ? 'Yes' : 'No'}
    onChange={(e) =>
      handleBooleanChange(type.documentTypeID, 'mandatoryInProcessFlow1', e.target.value)
    }
    disabled={readOnly}
    style={{ minWidth: 100 }}
  >
    <MenuItem value="Yes">Yes</MenuItem>
    <MenuItem value="No">No</MenuItem>
  </Select>
</TableCell>
<TableCell>
  <Select
    value={type.mandatoryInProcessFlow4 ? 'Yes' : 'No'}
    onChange={(e) =>
      handleBooleanChange(type.documentTypeID, 'mandatoryInProcessFlow4', e.target.value)
    }
    disabled={readOnly}
    style={{ minWidth: 100 }}
  >
    <MenuItem value="Yes">Yes</MenuItem>
    <MenuItem value="No">No</MenuItem>
  </Select>
</TableCell> */}
            </TableRow>
          ))}
        </TableBody>
      </Table>
    </TableContainer>
  );
};

const ProductTypes = ({
  productTypesData,
  setproductTypesData,
  isProdLoading,
  readOnly,
  productTypeTableErrors = {},
}) => {
  const classes = useStyles();
  const handleToggle = (id, checked) => {
    const updated = productTypesData.map((doc) =>
      doc.productTypeID === id ? { ...doc, activated: checked } : doc
    );
    setproductTypesData(updated);
  };

  const handleMandatoryChange = (id, name, value) => {
    setproductTypesData((prev) =>
      prev.map((doc) => {
        if (doc.productTypeID !== id) return doc;
        if (name === "consumptionDataReqdForIBDGRN" && value === "No") {
          return {
            ...doc,
            consumptionDataReqdForIBDGRN: false,
            uploadConsumptionData: false,
            consumptionSameAsAllocation: false,
            consumedQtyInfoPresent: null,
            consumedQtyMappedTo: null,
          };
        }
        if (name === "uploadConsumptionData" && value === "No") {
          return {
            ...doc,
            uploadConsumptionData: false,
            consumedQtyInfoPresent: null,
            consumedQtyMappedTo: null,
          };
        }
        if (name === "consumedQtyInfoPresent") {
          const newVal = value === "Yes" ? true : value === "No" ? false : null;
          return {
            ...doc,
            consumedQtyInfoPresent: newVal,
            consumedQtyMappedTo: newVal === true ? null : doc.consumedQtyMappedTo,
          };
        }
        if (name === "consumedQtyMappedTo") {
          const newVal = value === "BoM Qty" ? "bomQty" : value === "On-Hand Qty" ? "onHandQty" : null;
          return { ...doc, consumedQtyMappedTo: newVal };
        }
        if (name === "earlyPODateUpdateInERP") {
          return {
            ...doc,
            earlyPODateUpdateInERP: value === "Yes",
            earlyDateUpdateType: value === "No" ? null : (doc.earlyDateUpdateType || "Manual"),
          };
        }
        if (name === "laterPODateUpdateInERP") {
          return {
            ...doc,
            laterPODateUpdateInERP: value === "Yes",
            laterDateUpdateType: value === "No" ? null : (doc.laterDateUpdateType || "Manual"),
          };
        }
        if (name === "lessProducedQtyUpdateInERP") {
          return {
            ...doc,
            lessProducedQtyUpdateInERP: value === "Yes",
            lessProducedQtyUpdateType: value === "No" ? null : (doc.lessProducedQtyUpdateType || "Manual"),
          };
        }
        if (name === "moreProducedQtyUpdateInERP") {
          return {
            ...doc,
            moreProducedQtyUpdateInERP: value === "Yes",
            moreProducedQtyUpdateType: value === "No" ? null : (doc.moreProducedQtyUpdateType || "Manual"),
          };
        }
        const varianceLimitFields = [
          "earlyDateVarianceLimit", "laterDateVarianceLimit",
          "consumedQtyVarianceLimitPercentage",
          "lessProducedQtyVarianceLimitPercentage", "moreProducedQtyVarianceLimitPercentage",
        ];
        if (varianceLimitFields.includes(name)) {
          return { ...doc, [name]: value };
        }
        const updateTypeFields = ["earlyDateUpdateType", "laterDateUpdateType", "lessProducedQtyUpdateType", "moreProducedQtyUpdateType"];
        if (updateTypeFields.includes(name)) {
          return { ...doc, [name]: value === "NA" ? null : value };
        }
        return { ...doc, [name]: value === "Yes" };
      })
    );
  };

  if (isProdLoading) {
    return (
      <div className={classes.loaderContainer}>
        <CircularProgress color="primary" />
      </div>
    );
  }

  if (!productTypesData || productTypesData.length === 0) {
    return <Typography>No Product types available</Typography>;
  }
  return (
    <>
      {/* Table 1: Product Type Selection */}
      <div style={{ marginBottom: 60 }}>
        <div
          style={{
            fontFamily: "Roboto, Helvetica, Arial, sans-serif",
            fontWeight: 800,
            fontSize: 18,
           
          }}
        >
          Product Type Selection
        </div>
        <TableContainer component={Paper} className={classes.table}>
          <Table>
            <TableHead className={classes.tableHead}>
              <TableRow>
                <TableCell className={classes.tableCell}>Selection</TableCell>
                <TableCell className={classes.tableCell}>Product Type</TableCell>
                <TableCell className={classes.tableCell}>
                  Expiry Date Provided
                </TableCell>
              </TableRow>
            </TableHead>
            <TableBody>
              {productTypesData.map((type) => (
                <TableRow key={type.productTypeID}>
                  <TableCell>
                    <span style={{ position: "relative" }}>
                      <IOSSwitch
                        className={classes.iosSwitch}
                        color="primary"
                        checked={!!type.activated}
                        onChange={(e) =>
                          handleToggle(type.productTypeID, e.target.checked)
                        }
                        disabled={readOnly}
                      />
                      {!!type.activated && (
                        <Check className={classes.checkedSwitch} />
                      )}
                    </span>
                  </TableCell>
                  <TableCell>{type.productTypeName}</TableCell>
                  <TableCell>
                    <FormControl
                      variant="outlined"
                      size="small"
                      className={classes.mandatoryDropdown}
                    >
                      <Select
                        value={
                          typeof type.expiryDateProvided === "boolean"
                            ? type.expiryDateProvided
                              ? "Yes"
                              : "No"
                            : "Yes"
                        }
                        onChange={(e) =>
                          handleMandatoryChange(
                            type.productTypeID,
                            "expiryDateProvided",
                            e.target.value
                          )
                        }
                        disabled={readOnly}
                        displayEmpty
                      >
                        <MenuItem value="Yes">Yes</MenuItem>
                        <MenuItem value="No">No</MenuItem>
                      </Select>
                    </FormControl>
                  </TableCell>
                </TableRow>
              ))}
            </TableBody>
          </Table>
        </TableContainer>
      </div>

      {/* Table 2: Product Type Consumption Configurations */}
      <div  style={{ marginBottom: 60 }}>
        <div
          style={{
            fontFamily: "Roboto, Helvetica, Arial, sans-serif",
            fontWeight: 800,
            fontSize: 18,
          }}
        >
          Product Type Consumption Configurations
        </div>
        <TableContainer component={Paper} className={classes.table}>
          <Table>
            <TableHead className={classes.tableHead}>
              <TableRow>
                <TableCell className={classes.tableCell}>Product Type</TableCell>
                <TableCell className={classes.tableCell}>
                  Consumption info req. For IBD/GRN
                </TableCell>
                <TableCell className={classes.tableCell}>
                  Consumed batch info present
                </TableCell>
                <TableCell className={classes.tableCell}>
                  For multiple consumed batches, individual consumed qty info
                  present
                </TableCell>
                <TableCell className={classes.tableCell}>
                  Map consumed qty to
                </TableCell>
                <TableCell className={classes.tableCell}>
                  Consumption details = Allocation details
                </TableCell>
              </TableRow>
            </TableHead>
            <TableBody>
              {productTypesData.filter((type) => !!type.activated).map((type) => {
                const consumptionReqd =
                  typeof type.consumptionDataReqdForIBDGRN === "boolean"
                    ? type.consumptionDataReqdForIBDGRN
                    : false;
                const batchInfoPresent =
                  typeof type.uploadConsumptionData === "boolean"
                    ? type.uploadConsumptionData
                    : false;
                const indivQtyDisabled =
                  readOnly || !consumptionReqd || !batchInfoPresent;
                const mapQtyDisabled =
                  readOnly ||
                  !consumptionReqd ||
                  !batchInfoPresent ||
                  type.consumedQtyInfoPresent !== false;
                // Separate "not applicable" from "disabled for editing"
                const allocationNotApplicable = !consumptionReqd || batchInfoPresent;
                const allocationDisabled = readOnly || allocationNotApplicable;
                return (
                  <TableRow key={type.productTypeID}>
                    <TableCell>{type.productTypeName}</TableCell>
                    <TableCell>
                      <FormControl
                        variant="outlined"
                        size="small"
                        className={classes.mandatoryDropdown}
                      >
                        <Select
                          value={consumptionReqd ? "Yes" : "No"}
                          onChange={(e) =>
                            handleMandatoryChange(
                              type.productTypeID,
                              "consumptionDataReqdForIBDGRN",
                              e.target.value
                            )
                          }
                          disabled={readOnly}
                          displayEmpty
                        >
                          <MenuItem value="No">No</MenuItem>
                          <MenuItem value="Yes">Yes</MenuItem>
                        </Select>
                      </FormControl>
                    </TableCell>
                    <TableCell>
                      <FormControl
                        variant="outlined"
                        size="small"
                        className={classes.mandatoryDropdown}
                      >
                        <Select
                          value={
                            !consumptionReqd
                              ? "NA"
                              : batchInfoPresent
                              ? "Yes"
                              : "No"
                          }
                          onChange={(e) =>
                            handleMandatoryChange(
                              type.productTypeID,
                              "uploadConsumptionData",
                              e.target.value
                            )
                          }
                          displayEmpty
                          disabled={readOnly || !consumptionReqd}
                        >
                          {!consumptionReqd && (
                            <MenuItem value="NA">NA</MenuItem>
                          )}
                          <MenuItem value="No">No</MenuItem>
                          <MenuItem value="Yes">Yes</MenuItem>
                        </Select>
                      </FormControl>
                    </TableCell>
                    <TableCell>
                      <FormControl
                        variant="outlined"
                        size="small"
                        className={classes.mandatoryDropdown}
                      >
                        <Select
                          value={
                            type.consumedQtyInfoPresent === true
                              ? "Yes"
                              : type.consumedQtyInfoPresent === false
                              ? "No"
                              : "NA"
                          }
                          onChange={(e) =>
                            handleMandatoryChange(
                              type.productTypeID,
                              "consumedQtyInfoPresent",
                              e.target.value
                            )
                          }
                          disabled={indivQtyDisabled}
                          displayEmpty
                        >
                          <MenuItem value="NA" disabled={!indivQtyDisabled}>NA</MenuItem>
                          <MenuItem value="No">No</MenuItem>
                          <MenuItem value="Yes">Yes</MenuItem>
                        </Select>
                      </FormControl>
                    </TableCell>
                    <TableCell>
                      <FormControl
                        variant="outlined"
                        size="small"
                        className={classes.mandatoryDropdown}
                      >
                        <Select
                          value={
                            type.consumedQtyMappedTo === "onHandQty"
                              ? "On-Hand Qty"
                              : type.consumedQtyMappedTo === "bomQty"
                              ? "BoM Qty"
                              : "NA"
                          }
                          onChange={(e) =>
                            handleMandatoryChange(
                              type.productTypeID,
                              "consumedQtyMappedTo",
                              e.target.value
                            )
                          }
                          disabled={mapQtyDisabled}
                          displayEmpty
                        >
                          <MenuItem value="NA" disabled={!mapQtyDisabled}>NA</MenuItem>
                          <MenuItem value="BoM Qty">BoM Qty</MenuItem>
                          <MenuItem value="On-Hand Qty">On-Hand Qty</MenuItem>
                        </Select>
                      </FormControl>
                    </TableCell>
                    <TableCell>
                      <FormControl
                        variant="outlined"
                        size="small"
                        className={classes.mandatoryDropdown}
                      >
                        <Select
                          value={
                            allocationNotApplicable
                              ? "NA"
                              : typeof type.consumptionSameAsAllocation ===
                                "boolean"
                              ? type.consumptionSameAsAllocation
                                ? "Yes"
                                : "No"
                              : "NA"
                          }
                          onChange={(e) =>
                            handleMandatoryChange(
                              type.productTypeID,
                              "consumptionSameAsAllocation",
                              e.target.value
                            )
                          }
                          displayEmpty
                          disabled={allocationDisabled}
                        >
                          <MenuItem value="NA" disabled={!allocationNotApplicable}>NA</MenuItem>
                          <MenuItem value="No">No</MenuItem>
                          <MenuItem value="Yes">Yes</MenuItem>
                        </Select>
                      </FormControl>
                    </TableCell>
                  </TableRow>
                );
              })}
            </TableBody>
          </Table>
        </TableContainer>
      </div>

      {/* Table 3: Early Stat and Delivery Date */}
      <div  style={{ marginBottom: 60 }}>
        <div
          style={{
            fontFamily: "Roboto, Helvetica, Arial, sans-serif",
            fontWeight: 800,
            fontSize: 18,
            marginTop: 24,
          }}
        >
          Early Stat and Delivery Date (Batch Execution Acceptance Limits)
        </div>
        <TableContainer component={Paper} className={classes.table}>
          <Table>
            <colgroup>
              <col style={{ width: "22%" }} />
              <col style={{ width: "12%" }} />
              <col style={{ width: "24%" }} />
              <col style={{ width: "26%" }} />
              <col style={{ width: "16%" }} />
            </colgroup>
            <TableHead className={classes.tableHead}>
              <TableRow>
                <TableCell className={classes.tableCell}>Product Type</TableCell>
                <TableCell className={classes.tableCell}>Variance Limit (days) <span style={{ color: "red" }}>*</span></TableCell>
                <TableCell className={classes.tableCell}>Update PO Stat and Delivery Date in ERP <span style={{ color: "red" }}>*</span></TableCell>
                <TableCell className={classes.tableCell}>Update Type <span style={{ color: "red" }}>*</span></TableCell>
                <TableCell className={classes.tableCell}>Warning Message <span style={{ color: "red" }}>*</span></TableCell>
              </TableRow>
            </TableHead>
            <TableBody>
              {productTypesData.filter((type) => !!type.activated).map((type) => {
                const earlyUpdateTypeDisabled = readOnly || !type.earlyPODateUpdateInERP;
                return (
                  <TableRow key={type.productTypeID}>
                    <TableCell>{type.productTypeName}</TableCell>
                    <TableCell>
                      <TextField
                        variant="outlined"
                        size="small"
                        type="number"
                        value={type.earlyDateVarianceLimit ?? ""}
                        onChange={(e) => handleMandatoryChange(type.productTypeID, "earlyDateVarianceLimit", e.target.value)}
                        disabled={readOnly}
                        inputProps={{ min: 0 }}
                        onKeyDown={(e) => ['e', 'E', '+', '-', '.'].includes(e.key) && e.preventDefault()}
                        style={{ width: 90 }}
                        error={!!productTypeTableErrors.earlyStatTable && (type.earlyDateVarianceLimit == null || String(type.earlyDateVarianceLimit).trim() === "" || isNaN(parseInt(type.earlyDateVarianceLimit)))}
                      />
                    </TableCell>
                    <TableCell>
                      <FormControl variant="outlined" size="small" className={classes.mandatoryDropdown} error={!!productTypeTableErrors.earlyStatTable && type.earlyPODateUpdateInERP == null}>
                        <Select
                          value={type.earlyPODateUpdateInERP === true ? "Yes" : type.earlyPODateUpdateInERP === false ? "No" : ""}
                          onChange={(e) => handleMandatoryChange(type.productTypeID, "earlyPODateUpdateInERP", e.target.value)}
                          disabled={readOnly}
                          displayEmpty
                        >
                          {type.earlyPODateUpdateInERP == null && <MenuItem value="" disabled>-</MenuItem>}
                          <MenuItem value="No">No</MenuItem>
                          <MenuItem value="Yes">Yes</MenuItem>
                        </Select>
                      </FormControl>
                    </TableCell>
                    <TableCell>
                      <FormControl variant="outlined" size="small" className={classes.mandatoryDropdown} error={!!productTypeTableErrors.earlyStatTable && !!type.earlyPODateUpdateInERP && !type.earlyDateUpdateType}>
                        <Select
                          value={!type.earlyPODateUpdateInERP ? "NA" : (type.earlyDateUpdateType || "")}
                          onChange={(e) => handleMandatoryChange(type.productTypeID, "earlyDateUpdateType", e.target.value)}
                          disabled={earlyUpdateTypeDisabled}
                          displayEmpty
                        >
                          {!type.earlyPODateUpdateInERP && <MenuItem value="NA">NA</MenuItem>}
                          <MenuItem value="Manual">Manual</MenuItem>
                          <MenuItem value="Automatic after approval">Automatic after approval</MenuItem>
                          <MenuItem value="Automatic without approval">Automatic without approval</MenuItem>
                        </Select>
                      </FormControl>
                    </TableCell>
                    <TableCell>
                      <FormControl variant="outlined" size="small" className={classes.mandatoryDropdown} error={!!productTypeTableErrors.earlyStatTable && type.earlyDateWarningMessageRequired == null}>
                        <Select
                          value={type.earlyDateWarningMessageRequired === true ? "Yes" : type.earlyDateWarningMessageRequired === false ? "No" : ""}
                          onChange={(e) => handleMandatoryChange(type.productTypeID, "earlyDateWarningMessageRequired", e.target.value)}
                          disabled={readOnly}
                          displayEmpty
                        >
                          {type.earlyDateWarningMessageRequired == null && <MenuItem value="" disabled>-</MenuItem>}
                          <MenuItem value="No">No</MenuItem>
                          <MenuItem value="Yes">Yes</MenuItem>
                        </Select>
                      </FormControl>
                    </TableCell>
                  </TableRow>
                );
              })}
            </TableBody>
          </Table>
        </TableContainer>
        {productTypeTableErrors.earlyStatTable && (
          <Typography style={{ color: "#f44336", fontSize: 14, marginTop: 8, whiteSpace: "pre-line" }}>{productTypeTableErrors.earlyStatTable}</Typography>
        )}
      </div>

      {/* Table 4: Later Stat and Delivery Date */}
      <div style={{ marginBottom: 60 }}>
        <div
          style={{
            fontFamily: "Roboto, Helvetica, Arial, sans-serif",
            fontWeight: 800,
            fontSize: 18,
            marginTop: 24,
          }}
        >
          Later Stat and Delivery Date (Batch Execution Acceptance Limits)
        </div>
        <TableContainer component={Paper} className={classes.table}>
          <Table>
            <colgroup>
              <col style={{ width: "22%" }} />
              <col style={{ width: "12%" }} />
              <col style={{ width: "24%" }} />
              <col style={{ width: "26%" }} />
              <col style={{ width: "16%" }} />
            </colgroup>
            <TableHead className={classes.tableHead}>
              <TableRow>
                <TableCell className={classes.tableCell}>Product Type</TableCell>
                <TableCell className={classes.tableCell}>Variance Limit (days) <span style={{ color: "red" }}>*</span></TableCell>
                <TableCell className={classes.tableCell}>Update PO Stat and Delivery Date in ERP <span style={{ color: "red" }}>*</span></TableCell>
                <TableCell className={classes.tableCell}>Update Type <span style={{ color: "red" }}>*</span></TableCell>
                <TableCell className={classes.tableCell}>Warning Message <span style={{ color: "red" }}>*</span></TableCell>
              </TableRow>
            </TableHead>
            <TableBody>
              {productTypesData.filter((type) => !!type.activated).map((type) => {
                const laterUpdateTypeDisabled = readOnly || !type.laterPODateUpdateInERP;
                return (
                  <TableRow key={type.productTypeID}>
                    <TableCell>{type.productTypeName}</TableCell>
                    <TableCell>
                      <TextField
                        variant="outlined"
                        size="small"
                        type="number"
                        value={type.laterDateVarianceLimit ?? ""}
                        onChange={(e) => handleMandatoryChange(type.productTypeID, "laterDateVarianceLimit", e.target.value)}
                        disabled={readOnly}
                        inputProps={{ min: 0 }}
                        onKeyDown={(e) => ['e', 'E', '+', '-', '.'].includes(e.key) && e.preventDefault()}
                        style={{ width: 90 }}
                        error={!!productTypeTableErrors.laterStatTable && (type.laterDateVarianceLimit == null || String(type.laterDateVarianceLimit).trim() === "" || isNaN(parseInt(type.laterDateVarianceLimit)))}
                      />
                    </TableCell>
                    <TableCell>
                      <FormControl variant="outlined" size="small" className={classes.mandatoryDropdown} error={!!productTypeTableErrors.laterStatTable && type.laterPODateUpdateInERP == null}>
                        <Select
                          value={type.laterPODateUpdateInERP === true ? "Yes" : type.laterPODateUpdateInERP === false ? "No" : ""}
                          onChange={(e) => handleMandatoryChange(type.productTypeID, "laterPODateUpdateInERP", e.target.value)}
                          disabled={readOnly}
                          displayEmpty
                        >
                          {type.laterPODateUpdateInERP == null && <MenuItem value="" disabled>-</MenuItem>}
                          <MenuItem value="No">No</MenuItem>
                          <MenuItem value="Yes">Yes</MenuItem>
                        </Select>
                      </FormControl>
                    </TableCell>
                    <TableCell>
                      <FormControl variant="outlined" size="small" className={classes.mandatoryDropdown} error={!!productTypeTableErrors.laterStatTable && !!type.laterPODateUpdateInERP && !type.laterDateUpdateType}>
                        <Select
                          value={!type.laterPODateUpdateInERP ? "NA" : (type.laterDateUpdateType || "")}
                          onChange={(e) => handleMandatoryChange(type.productTypeID, "laterDateUpdateType", e.target.value)}
                          disabled={laterUpdateTypeDisabled}
                          displayEmpty
                        >
                          {!type.laterPODateUpdateInERP && <MenuItem value="NA">NA</MenuItem>}
                          <MenuItem value="Manual">Manual</MenuItem>
                          <MenuItem value="Automatic after approval">Automatic after approval</MenuItem>
                          <MenuItem value="Automatic without approval">Automatic without approval</MenuItem>
                        </Select>
                      </FormControl>
                    </TableCell>
                    <TableCell>
                      <FormControl variant="outlined" size="small" className={classes.mandatoryDropdown} error={!!productTypeTableErrors.laterStatTable && type.laterDateWarningMessageRequired == null}>
                        <Select
                          value={type.laterDateWarningMessageRequired === true ? "Yes" : type.laterDateWarningMessageRequired === false ? "No" : ""}
                          onChange={(e) => handleMandatoryChange(type.productTypeID, "laterDateWarningMessageRequired", e.target.value)}
                          disabled={readOnly}
                          displayEmpty
                        >
                          {type.laterDateWarningMessageRequired == null && <MenuItem value="" disabled>-</MenuItem>}
                          <MenuItem value="No">No</MenuItem>
                          <MenuItem value="Yes">Yes</MenuItem>
                        </Select>
                      </FormControl>
                    </TableCell>
                  </TableRow>
                );
              })}
            </TableBody>
          </Table>
        </TableContainer>
        {productTypeTableErrors.laterStatTable && (
          <Typography style={{ color: "#f44336", fontSize: 14, marginTop: 8, whiteSpace: "pre-line" }}>{productTypeTableErrors.laterStatTable}</Typography>
        )}
      </div>

      {/* Table 5: Consumed Batch */}
      <div style={{ marginBottom: 60 }}>
        <div
          style={{
            fontFamily: "Roboto, Helvetica, Arial, sans-serif",
            fontWeight: 800,
            fontSize: 18,
            marginTop: 24,
          }}
        >
          Consumed Batch (Batch Execution Acceptance Limits)
        </div>
        <TableContainer component={Paper} className={classes.table}>
          <Table>
            <colgroup>
              <col style={{ width: "18%" }} />
              <col style={{ width: "12%" }} />
              <col style={{ width: "14%" }} />
              <col style={{ width: "14%" }} />
              <col style={{ width: "21%" }} />
              <col style={{ width: "21%" }} />
            </colgroup>
            <TableHead className={classes.tableHead}>
              <TableRow>
                <TableCell className={classes.tableCell}>Product Type</TableCell>
                <TableCell className={classes.tableCell}>Qty Variance Limit (±%) <span style={{ color: "red" }}>*</span></TableCell>
                <TableCell className={classes.tableCell}>Approval Required <span style={{ color: "red" }}>*</span></TableCell>
                <TableCell className={classes.tableCell}>Warning Message <span style={{ color: "red" }}>*</span></TableCell>
                <TableCell className={classes.tableCell}>Batch Mismatch - Approval Required <span style={{ color: "red" }}>*</span></TableCell>
                <TableCell className={classes.tableCell}>Batch Mismatch - Warning Message <span style={{ color: "red" }}>*</span></TableCell>
              </TableRow>
            </TableHead>
            <TableBody>
              {productTypesData.filter((type) => !!type.activated).map((type) => (
                <TableRow key={type.productTypeID}>
                  <TableCell>{type.productTypeName}</TableCell>
                  <TableCell>
                    <TextField
                      variant="outlined"
                      size="small"
                      type="number"
                      value={type.consumedQtyVarianceLimitPercentage ?? ""}
                      onChange={(e) => handleMandatoryChange(type.productTypeID, "consumedQtyVarianceLimitPercentage", e.target.value)}
                      disabled={readOnly}
                      inputProps={{ min: 0 }}
                      onKeyDown={(e) => ['e', 'E', '+', '-', '.'].includes(e.key) && e.preventDefault()}
                      style={{ width: 90 }}
                      error={!!productTypeTableErrors.consumedBatchTable && (type.consumedQtyVarianceLimitPercentage == null || String(type.consumedQtyVarianceLimitPercentage).trim() === "" || isNaN(parseInt(type.consumedQtyVarianceLimitPercentage)))}
                    />
                  </TableCell>
                  <TableCell>
                    <FormControl variant="outlined" size="small" className={classes.mandatoryDropdown} error={!!productTypeTableErrors.consumedBatchTable && type.consumedQtyVarianceApprovalRequired == null}>
                      <Select
                        value={type.consumedQtyVarianceApprovalRequired === true ? "Yes" : type.consumedQtyVarianceApprovalRequired === false ? "No" : ""}
                        onChange={(e) => handleMandatoryChange(type.productTypeID, "consumedQtyVarianceApprovalRequired", e.target.value)}
                        disabled={readOnly}
                        displayEmpty
                      >
                        {type.consumedQtyVarianceApprovalRequired == null && <MenuItem value="" disabled>-</MenuItem>}
                        <MenuItem value="No">No</MenuItem>
                        <MenuItem value="Yes">Yes</MenuItem>
                      </Select>
                    </FormControl>
                  </TableCell>
                  <TableCell>
                    <FormControl variant="outlined" size="small" className={classes.mandatoryDropdown} error={!!productTypeTableErrors.consumedBatchTable && type.consumedQtyVarianceWarningMessageRequired == null}>
                      <Select
                        value={type.consumedQtyVarianceWarningMessageRequired === true ? "Yes" : type.consumedQtyVarianceWarningMessageRequired === false ? "No" : ""}
                        onChange={(e) => handleMandatoryChange(type.productTypeID, "consumedQtyVarianceWarningMessageRequired", e.target.value)}
                        disabled={readOnly}
                        displayEmpty
                      >
                        {type.consumedQtyVarianceWarningMessageRequired == null && <MenuItem value="" disabled>-</MenuItem>}
                        <MenuItem value="No">No</MenuItem>
                        <MenuItem value="Yes">Yes</MenuItem>
                      </Select>
                    </FormControl>
                  </TableCell>
                  <TableCell>
                    <FormControl variant="outlined" size="small" className={classes.mandatoryDropdown} error={!!productTypeTableErrors.consumedBatchTable && type.lotMismatchApprovalRequired == null}>
                      <Select
                        value={type.lotMismatchApprovalRequired === true ? "Yes" : type.lotMismatchApprovalRequired === false ? "No" : ""}
                        onChange={(e) => handleMandatoryChange(type.productTypeID, "lotMismatchApprovalRequired", e.target.value)}
                        disabled={readOnly}
                        displayEmpty
                      >
                        {type.lotMismatchApprovalRequired == null && <MenuItem value="" disabled>-</MenuItem>}
                        <MenuItem value="No">No</MenuItem>
                        <MenuItem value="Yes">Yes</MenuItem>
                      </Select>
                    </FormControl>
                  </TableCell>
                  <TableCell>
                    <FormControl variant="outlined" size="small" className={classes.mandatoryDropdown} error={!!productTypeTableErrors.consumedBatchTable && type.lotMismatchWarningMessageRequired == null}>
                      <Select
                        value={type.lotMismatchWarningMessageRequired === true ? "Yes" : type.lotMismatchWarningMessageRequired === false ? "No" : ""}
                        onChange={(e) => handleMandatoryChange(type.productTypeID, "lotMismatchWarningMessageRequired", e.target.value)}
                        disabled={readOnly}
                        displayEmpty
                      >
                        {type.lotMismatchWarningMessageRequired == null && <MenuItem value="" disabled>-</MenuItem>}
                        <MenuItem value="No">No</MenuItem>
                        <MenuItem value="Yes">Yes</MenuItem>
                      </Select>
                    </FormControl>
                  </TableCell>
                </TableRow>
              ))}
            </TableBody>
          </Table>
        </TableContainer>
        {productTypeTableErrors.consumedBatchTable && (
          <Typography style={{ color: "#f44336", fontSize: 14, marginTop: 8, whiteSpace: "pre-line" }}>{productTypeTableErrors.consumedBatchTable}</Typography>
        )}
      </div>

      {/* Table 6: Less Produced Qty Variance */}
      <div style={{ marginBottom: 60 }}>
        <div
          style={{
            fontFamily: "Roboto, Helvetica, Arial, sans-serif",
            fontWeight: 800,
            fontSize: 18,
            marginTop: 24,
          }}
        >
          Less Produced Qty Variance (Batch Execution Acceptance Limits)
        </div>
        <TableContainer component={Paper} className={classes.table}>
          <Table>
            <colgroup>
              <col style={{ width: "22%" }} />
              <col style={{ width: "12%" }} />
              <col style={{ width: "24%" }} />
              <col style={{ width: "26%" }} />
              <col style={{ width: "16%" }} />
            </colgroup>
            <TableHead className={classes.tableHead}>
              <TableRow>
                <TableCell className={classes.tableCell}>Product Type</TableCell>
                <TableCell className={classes.tableCell}>Variance Limit (%) <span style={{ color: "red" }}>*</span></TableCell>
                <TableCell className={classes.tableCell}>Update PO Qty in ERP <span style={{ color: "red" }}>*</span></TableCell>
                <TableCell className={classes.tableCell}>Update Type <span style={{ color: "red" }}>*</span></TableCell>
                <TableCell className={classes.tableCell}>Warning Message <span style={{ color: "red" }}>*</span></TableCell>
              </TableRow>
            </TableHead>
            <TableBody>
              {productTypesData.filter((type) => !!type.activated).map((type) => {
                const lessUpdateTypeDisabled = readOnly || !type.lessProducedQtyUpdateInERP;
                return (
                  <TableRow key={type.productTypeID}>
                    <TableCell>{type.productTypeName}</TableCell>
                    <TableCell>
                      <TextField
                        variant="outlined"
                        size="small"
                        type="number"
                        value={type.lessProducedQtyVarianceLimitPercentage ?? ""}
                        onChange={(e) => handleMandatoryChange(type.productTypeID, "lessProducedQtyVarianceLimitPercentage", e.target.value)}
                        disabled={readOnly}
                        inputProps={{ min: 0 }}
                        onKeyDown={(e) => ['e', 'E', '+', '-', '.'].includes(e.key) && e.preventDefault()}
                        style={{ width: 90 }}
                        error={!!productTypeTableErrors.lessProducedTable && (type.lessProducedQtyVarianceLimitPercentage == null || String(type.lessProducedQtyVarianceLimitPercentage).trim() === "" || isNaN(parseInt(type.lessProducedQtyVarianceLimitPercentage)))}
                      />
                    </TableCell>
                    <TableCell>
                      <FormControl variant="outlined" size="small" className={classes.mandatoryDropdown} error={!!productTypeTableErrors.lessProducedTable && type.lessProducedQtyUpdateInERP == null}>
                        <Select
                          value={type.lessProducedQtyUpdateInERP === true ? "Yes" : type.lessProducedQtyUpdateInERP === false ? "No" : ""}
                          onChange={(e) => handleMandatoryChange(type.productTypeID, "lessProducedQtyUpdateInERP", e.target.value)}
                          disabled={readOnly}
                          displayEmpty
                        >
                          {type.lessProducedQtyUpdateInERP == null && <MenuItem value="" disabled>-</MenuItem>}
                          <MenuItem value="No">No</MenuItem>
                          <MenuItem value="Yes">Yes</MenuItem>
                        </Select>
                      </FormControl>
                    </TableCell>
                    <TableCell>
                      <FormControl variant="outlined" size="small" className={classes.mandatoryDropdown} error={!!productTypeTableErrors.lessProducedTable && !!type.lessProducedQtyUpdateInERP && !type.lessProducedQtyUpdateType}>
                        <Select
                          value={!type.lessProducedQtyUpdateInERP ? "NA" : (type.lessProducedQtyUpdateType || "")}
                          onChange={(e) => handleMandatoryChange(type.productTypeID, "lessProducedQtyUpdateType", e.target.value)}
                          disabled={lessUpdateTypeDisabled}
                          displayEmpty
                        >
                          {!type.lessProducedQtyUpdateInERP && <MenuItem value="NA">NA</MenuItem>}
                          <MenuItem value="Manual">Manual</MenuItem>
                          <MenuItem value="Automatic after approval">Automatic after approval</MenuItem>
                          <MenuItem value="Automatic without approval">Automatic without approval</MenuItem>
                        </Select>
                      </FormControl>
                    </TableCell>
                    <TableCell>
                      <FormControl variant="outlined" size="small" className={classes.mandatoryDropdown} error={!!productTypeTableErrors.lessProducedTable && type.lessProducedQtyWarningMessageRequired == null}>
                        <Select
                          value={type.lessProducedQtyWarningMessageRequired === true ? "Yes" : type.lessProducedQtyWarningMessageRequired === false ? "No" : ""}
                          onChange={(e) => handleMandatoryChange(type.productTypeID, "lessProducedQtyWarningMessageRequired", e.target.value)}
                          disabled={readOnly}
                          displayEmpty
                        >
                          {type.lessProducedQtyWarningMessageRequired == null && <MenuItem value="" disabled>-</MenuItem>}
                          <MenuItem value="No">No</MenuItem>
                          <MenuItem value="Yes">Yes</MenuItem>
                        </Select>
                      </FormControl>
                    </TableCell>
                  </TableRow>
                );
              })}
            </TableBody>
          </Table>
        </TableContainer>
        {productTypeTableErrors.lessProducedTable && (
          <Typography style={{ color: "#f44336", fontSize: 14, marginTop: 8, whiteSpace: "pre-line" }}>{productTypeTableErrors.lessProducedTable}</Typography>
        )}
      </div>

      {/* Table 7: More Produced Qty Variance */}
      <div style={{ marginBottom: 60 }}>
        <div
          style={{
            fontFamily: "Roboto, Helvetica, Arial, sans-serif",
            fontWeight: 800,
            fontSize: 18,
            marginTop: 24,
          }}
        >
          More Produced Qty Variance (Batch Execution Acceptance Limits)
        </div>
        <TableContainer component={Paper} className={classes.table}>
          <Table>
            <colgroup>
              <col style={{ width: "22%" }} />
              <col style={{ width: "12%" }} />
              <col style={{ width: "24%" }} />
              <col style={{ width: "26%" }} />
              <col style={{ width: "16%" }} />
            </colgroup>
            <TableHead className={classes.tableHead}>
              <TableRow>
                <TableCell className={classes.tableCell}>Product Type</TableCell>
                <TableCell className={classes.tableCell}>Variance Limit (%) <span style={{ color: "red" }}>*</span></TableCell>
                <TableCell className={classes.tableCell}>Update PO Qty in ERP <span style={{ color: "red" }}>*</span></TableCell>
                <TableCell className={classes.tableCell}>Update Type <span style={{ color: "red" }}>*</span></TableCell>
                <TableCell className={classes.tableCell}>Warning Message <span style={{ color: "red" }}>*</span></TableCell>
              </TableRow>
            </TableHead>
            <TableBody>
              {productTypesData.filter((type) => !!type.activated).map((type) => {
                const moreUpdateTypeDisabled = readOnly || !type.moreProducedQtyUpdateInERP;
                return (
                  <TableRow key={type.productTypeID}>
                    <TableCell>{type.productTypeName}</TableCell>
                    <TableCell>
                      <TextField
                        variant="outlined"
                        size="small"
                        type="number"
                        value={type.moreProducedQtyVarianceLimitPercentage ?? ""}
                        onChange={(e) => handleMandatoryChange(type.productTypeID, "moreProducedQtyVarianceLimitPercentage", e.target.value)}
                        disabled={readOnly}
                        inputProps={{ min: 0 }}
                        onKeyDown={(e) => ['e', 'E', '+', '-', '.'].includes(e.key) && e.preventDefault()}
                        style={{ width: 90 }}
                        error={!!productTypeTableErrors.moreProducedTable && (type.moreProducedQtyVarianceLimitPercentage == null || String(type.moreProducedQtyVarianceLimitPercentage).trim() === "" || isNaN(parseInt(type.moreProducedQtyVarianceLimitPercentage)))}
                      />
                    </TableCell>
                    <TableCell>
                      <FormControl variant="outlined" size="small" className={classes.mandatoryDropdown} error={!!productTypeTableErrors.moreProducedTable && type.moreProducedQtyUpdateInERP == null}>
                        <Select
                          value={type.moreProducedQtyUpdateInERP === true ? "Yes" : type.moreProducedQtyUpdateInERP === false ? "No" : ""}
                          onChange={(e) => handleMandatoryChange(type.productTypeID, "moreProducedQtyUpdateInERP", e.target.value)}
                          disabled={readOnly}
                          displayEmpty
                        >
                          {type.moreProducedQtyUpdateInERP == null && <MenuItem value="" disabled>-</MenuItem>}
                          <MenuItem value="No">No</MenuItem>
                          <MenuItem value="Yes">Yes</MenuItem>
                        </Select>
                      </FormControl>
                    </TableCell>
                    <TableCell>
                      <FormControl variant="outlined" size="small" className={classes.mandatoryDropdown} error={!!productTypeTableErrors.moreProducedTable && !!type.moreProducedQtyUpdateInERP && !type.moreProducedQtyUpdateType}>
                        <Select
                          value={!type.moreProducedQtyUpdateInERP ? "NA" : (type.moreProducedQtyUpdateType || "")}
                          onChange={(e) => handleMandatoryChange(type.productTypeID, "moreProducedQtyUpdateType", e.target.value)}
                          disabled={moreUpdateTypeDisabled}
                          displayEmpty
                        >
                          {!type.moreProducedQtyUpdateInERP && <MenuItem value="NA">NA</MenuItem>}
                          <MenuItem value="Manual">Manual</MenuItem>
                          <MenuItem value="Automatic after approval">Automatic after approval</MenuItem>
                          <MenuItem value="Automatic without approval">Automatic without approval</MenuItem>
                        </Select>
                      </FormControl>
                    </TableCell>
                    <TableCell>
                      <FormControl variant="outlined" size="small" className={classes.mandatoryDropdown} error={!!productTypeTableErrors.moreProducedTable && type.moreProducedQtyWarningMessageRequired == null}>
                        <Select
                          value={type.moreProducedQtyWarningMessageRequired === true ? "Yes" : type.moreProducedQtyWarningMessageRequired === false ? "No" : ""}
                          onChange={(e) => handleMandatoryChange(type.productTypeID, "moreProducedQtyWarningMessageRequired", e.target.value)}
                          disabled={readOnly}
                          displayEmpty
                        >
                          {type.moreProducedQtyWarningMessageRequired == null && <MenuItem value="" disabled>-</MenuItem>}
                          <MenuItem value="No">No</MenuItem>
                          <MenuItem value="Yes">Yes</MenuItem>
                        </Select>
                      </FormControl>
                    </TableCell>
                  </TableRow>
                );
              })}
            </TableBody>
          </Table>
        </TableContainer>
        {productTypeTableErrors.moreProducedTable && (
          <Typography style={{ color: "#f44336", fontSize: 14, marginTop: 8, whiteSpace: "pre-line" }}>{productTypeTableErrors.moreProducedTable}</Typography>
        )}
      </div>
    </>
  );
};

// Maps API mosymphonyDisplayOptions (objectsToUseVendorLevelData / objectsToUseMfgPlantLevelData) to internal UI shape (purchaseOrders, batches, etc. with "vendorLevel" | "plantLevel")
const mapMosymphonyDisplayOptionsFromApi = (apiOptions) => {
  if (!apiOptions || !Array.isArray(apiOptions) || apiOptions.length === 0 || !apiOptions[0]?.objectsToUseVendorLevelData) {
    return {
      purchaseOrders: "",
      batches: "",
      inactivePOs: "",
      inventory: "",
      forecast: "vendorLevel", // Forecast is always at vendor level
    };
  }
  const v = apiOptions[0].objectsToUseVendorLevelData;
  const m = apiOptions[0].objectsToUseMfgPlantLevelData || {};
  return {
    purchaseOrders: v.purchaseOrder ? "vendorLevel" : (m.purchaseOrder ? "plantLevel" : ""),
    batches: v.batches ? "vendorLevel" : (m.batches ? "plantLevel" : ""),
    inactivePOs: v.inactivePOs ? "vendorLevel" : (m.inactivePOs ? "plantLevel" : ""),
    inventory: v.inventory ? "vendorLevel" : (m.inventory ? "plantLevel" : ""),
    forecast: "vendorLevel", // Forecast is always at vendor level
  };
};

// Maps internal UI shape to API mosymphonyDisplayOptions for updateStepData / API payload
const mapMosymphonyDisplayOptionsToApi = (internalOptions) => {
  const opt = internalOptions || {};
  return [{
    objectsToUseVendorLevelData: {
      purchaseOrder: opt.purchaseOrders === "vendorLevel",
      batches: opt.batches === "vendorLevel",
      inactivePOs: opt.inactivePOs === "vendorLevel",
      inventory: opt.inventory === "vendorLevel",
      forecast: opt.forecast === "vendorLevel",
    },
    objectsToUseMfgPlantLevelData: {
      purchaseOrder: opt.purchaseOrders === "plantLevel",
      batches: opt.batches === "plantLevel",
      inactivePOs: opt.inactivePOs === "plantLevel",
      inventory: opt.inventory === "plantLevel",
      forecast: opt.forecast === "plantLevel",
    },
  }];
};

// --- Ingestion Configuration ---
// Removed hardcoded ingestionDataElements - will fetch from API

const ingestionCategoryOptions = ["PO Collaboration", "Inventory"];
const ingestThroughOptions = [
  { value: "Excel (Via Email)", disabled: false },
  { value: "Excel (download/upload through UI)", disabled: false },
  { value: "PDF (Via Email)", disabled: true },
  { value: "IDOC", disabled: true },
];
const ingestionFieldTypeOptions = [
  "Chain of custody",
  "First Choice",
  "Second Choice",
];
const ingestionValueOptions = ["Mandatory", "Not Mandatory", "Do not read"];

let ingestionIdCounter = 0;
const genIngestionId = () => `ing_${Date.now()}_${++ingestionIdCounter}`;

// Helper to find next available ingestionConfigId
const getNextIngestionConfigId = (sections) => {
  const existingIds = sections
    .map(s => s.ingestionConfigId)
    .filter(id => typeof id === 'number');
  return existingIds.length > 0 ? Math.max(...existingIds) + 1 : 1;
};

const createNewColumn = () => ({
  id: genIngestionId(),
  columnName: "",
  fieldType: "",
  dataElement: "",
  dataElementId: null,
  dataElementLabel: "",
  ingestion: "",
  ingestionConfigColumnId: null,
  markForDelete: false,
  columnNameError: false,
});

const createNewTab = () => ({
  id: genIngestionId(),
  tabName: "",
  columns: [createNewColumn()],
});

const createNewIngestionSection = () => ({
  id: genIngestionId(),
  category: "",
  ingestThrough: "",
  fileHasMultipleTabs: "Yes",
  tabs: [createNewTab()],
});

// Helper function to map API ingestionConfigurations to UI format
const mapIngestionConfigurationsFromApi = (apiConfigurations) => {
  if (!apiConfigurations || !Array.isArray(apiConfigurations)) {
    return [createNewIngestionSection()];
  }

  // "Inbound Idoc Configuration" entries are managed separately via the Configure IDoc
  // Ingestion dialog (Module Messages) and shouldn't surface in this general section —
  // this covers the Add stepper, Review step, and View page, which all render this
  // component (as ShipmentConfigurations/IngestionConfiguration) against the same API data.
  const nonIdocConfigurations = apiConfigurations.filter(
    (section) => section.category !== "Inbound Idoc Configuration"
  );
  if (nonIdocConfigurations.length === 0) {
    return [createNewIngestionSection()];
  }

  return nonIdocConfigurations.map((section) => ({
    id: section.id || genIngestionId(),
    ingestionConfigId: section.ingestionConfigId,
    category: section.category || "",
    ingestThrough: section.ingestThrough || "",
    fileHasMultipleTabs: typeof section.fileHasMultipleTabs === "boolean" 
      ? (section.fileHasMultipleTabs ? "Yes" : "No")
      : section.fileHasMultipleTabs || "Yes",
    // API returns markForDelete as a string ("false"/"true")
    markForDelete: section.markForDelete === true || section.markForDelete === "true",
    tabs: section.columnMappings && Array.isArray(section.columnMappings) 
      ? Object.values(
          section.columnMappings.reduce((acc, col) => {
            const tabName = col.tabName || "";
            if (!acc[tabName]) {
              acc[tabName] = {
                id: genIngestionId(),
                tabName: tabName,
                columns: []
              };
            }
            acc[tabName].columns.push({
              id: col.id || genIngestionId(),
              columnName: col.columnName || "",
              fieldType: col.fieldType || "",
              dataElement: col.dataElement || "",
              dataElementId: col.dataElementId || null,
              dataElementLabel: col.dataElementLabel || col.dataElement || "",
              ingestion: col.ingestion || "",
              ingestionConfigColumnId: col.ingestionConfigColumnId || null,
              markForDelete: col.markForDelete || false,
            });
            return acc;
          }, {})
        )
      : section.tabs && Array.isArray(section.tabs)
      ? section.tabs.map((tab) => ({
          id: tab.id || genIngestionId(),
          tabName: tab.tabName || "",
          columns: tab.columns && Array.isArray(tab.columns)
            ? tab.columns.map((col) => ({
                id: col.id || genIngestionId(),
                columnName: col.columnName || "",
                fieldType: col.fieldType || "",
                dataElement: col.dataElement || "",
                dataElementId: col.dataElementId || null,
                dataElementLabel: col.dataElementLabel || col.dataElement || "",
                ingestion: col.ingestion || "",
                ingestionConfigColumnId: col.ingestionConfigColumnId || null,
                markForDelete: col.markForDelete || false,
              }))
            : [createNewColumn()],
        }))
      : [createNewTab()],
  }));
};

const IngestionConfiguration = ({
  ingestionSections,
  setIngestionSections,
  readOnly,
  dataElements,
  isDataElementsLoading,
}) => {
  const classes = useStyles();
  const [dataElementEditState, setDataElementEditState] = useState({});
  const [dataElementEditPrev, setDataElementEditPrev] = useState({});

  const handleSectionFieldChange = (sectionId, field, value) => {
    setIngestionSections((prev) =>
      prev.map((section) => {
        if (section.id !== sectionId) return section;
        const updated = { ...section, [field]: value };
        if (field === "fileHasMultipleTabs" && value === "No") {
          updated.tabs = [{ ...updated.tabs[0], tabName: "" }];
        }
        return updated;
      })
    );
  };

  const handleTabNameChange = (sectionId, tabId, value) => {
    setIngestionSections((prev) =>
      prev.map((section) => {
        if (section.id !== sectionId) return section;
        return {
          ...section,
          tabs: section.tabs.map((tab) =>
            tab.id === tabId ? { ...tab, tabName: value } : tab
          ),
        };
      })
    );
  };

  const handleTabNameBlur = (sectionId, tabId) => {
    setIngestionSections((prev) =>
      prev.map((section) => {
        if (section.id !== sectionId) return section;
        return {
          ...section,
          tabs: section.tabs.map((tab) =>
            tab.id === tabId ? { ...tab, tabName: tab.tabName.trim() } : tab
          ),
        };
      })
    );
  };

  const validateColumnNamesInTab = (tab) => {
    const activeColumns = tab.columns.filter(col => !col.markForDelete);
    const columnNameCounts = {};
    activeColumns.forEach(col => {
      const trimmedName = col.columnName.trim().toLowerCase();
      if (trimmedName) {
        columnNameCounts[trimmedName] = (columnNameCounts[trimmedName] || 0) + 1;
      }
    });
    return activeColumns.map(col => {
      const trimmedName = col.columnName.trim().toLowerCase();
      return {
        ...col,
        columnNameError: trimmedName && columnNameCounts[trimmedName] > 1
      };
    });
  };

  const handleColumnChange = (sectionId, tabId, columnId, field, value) => {
    setIngestionSections((prev) =>
      prev.map((section) => {
        if (section.id !== sectionId) return section;
        return {
          ...section,
          tabs: section.tabs.map((tab) => {
            if (tab.id !== tabId) return tab;
            let updatedColumns = tab.columns.map((col) => {
              if (col.id !== columnId) return col;
              const updated = { ...col, [field]: value };
              if (field === "fieldType" && value === "Chain of custody") {
                updated.ingestion = "Mandatory";
              }
              if (
                field === "fieldType" &&
                col.fieldType === "Chain of custody" &&
                value !== "Chain of custody"
              ) {
                updated.ingestion = "";
              }
              return updated;
            });
            // Validate column names if columnName field was changed
            if (field === "columnName") {
              updatedColumns = validateColumnNamesInTab({ ...tab, columns: updatedColumns });
            }
            return {
              ...tab,
              columns: updatedColumns,
            };
          }),
        };
      })
    );
  };

  const handleDataElementChange = (sectionId, tabId, columnId, dataElementId, dataElementKey, dataElementLabel) => {
    setIngestionSections((prev) =>
      prev.map((section) => {
        if (section.id !== sectionId) return section;
        return {
          ...section,
          tabs: section.tabs.map((tab) => {
            if (tab.id !== tabId) return tab;
            return {
              ...tab,
              columns: tab.columns.map((col) => {
                if (col.id !== columnId) return col;
                return {
                  ...col,
                  dataElementId: dataElementId,
                  dataElement: dataElementKey,
                  dataElementLabel: dataElementLabel,
                };
              }),
            };
          }),
        };
      })
    );
  };

  const handleColumnNameBlur = (sectionId, tabId, columnId) => {
    setIngestionSections((prev) =>
      prev.map((section) => {
        if (section.id !== sectionId) return section;
        return {
          ...section,
          tabs: section.tabs.map((tab) => {
            if (tab.id !== tabId) return tab;
            let updatedColumns = tab.columns.map((col) => {
              if (col.id !== columnId) return col;
              return { ...col, columnName: col.columnName.trim() };
            });
            // Validate column names on blur
            updatedColumns = validateColumnNamesInTab({ ...tab, columns: updatedColumns });
            return {
              ...tab,
              columns: updatedColumns,
            };
          }),
        };
      })
    );
  };

  const addColumn = (sectionId, tabId) => {
    setIngestionSections((prev) =>
      prev.map((section) => {
        if (section.id !== sectionId) return section;
        return {
          ...section,
          tabs: section.tabs.map((tab) => {
            if (tab.id !== tabId) return tab;
            return { ...tab, columns: [...tab.columns, createNewColumn()] };
          }),
        };
      })
    );
  };

  const removeColumn = (sectionId, tabId, columnId) => {
    // Clean up edit state for the deleted column
    setDataElementEditState((prev) => {
      const newState = { ...prev };
      delete newState[columnId];
      return newState;
    });
    setDataElementEditPrev((prev) => {
      const newPrev = { ...prev };
      delete newPrev[columnId];
      return newPrev;
    });

    setIngestionSections((prev) =>
      prev.map((section) => {
        if (section.id !== sectionId) return section;
        return {
          ...section,
          tabs: section.tabs.map((tab) => {
            if (tab.id !== tabId) return tab;
            if (tab.columns.length <= 1) return tab;
            return {
              ...tab,
              // Saved columns are kept and flagged so the backend can delete them; unsaved ones are dropped
              columns: tab.columns
                .filter((col) => col.id !== columnId || col.ingestionConfigColumnId)
                .map((col) =>
                  col.id === columnId ? { ...col, markForDelete: true } : col
                ),
            };
          }),
        };
      })
    );
  };

  const addTab = (sectionId) => {
    setIngestionSections((prev) =>
      prev.map((section) => {
        if (section.id !== sectionId) return section;
        return { ...section, tabs: [...section.tabs, createNewTab()] };
      })
    );
  };

  const removeTab = (sectionId, tabId) => {
    setIngestionSections((prev) => {
      const updatedSections = prev.map((section) => {
        if (section.id !== sectionId) return section;
        return {
          ...section,
          tabs: section.tabs
            .map((tab) => {
              if (tab.id !== tabId) return tab;
              // Flag saved columns for deletion; unsaved ones are dropped
              return {
                ...tab,
                columns: tab.columns
                  .filter((col) => col.ingestionConfigColumnId)
                  .map((col) => ({ ...col, markForDelete: true })),
              };
            })
            .filter((tab) => tab.columns.length > 0),
        };
      });

      // Clean up edit state for all columns in the deleted tab
      const section = prev.find((s) => s.id === sectionId);
      const tab = section?.tabs.find((t) => t.id === tabId);
      if (tab) {
        setDataElementEditState((prevState) => {
          const newState = { ...prevState };
          tab.columns.forEach((col) => {
            delete newState[col.id];
          });
          return newState;
        });
        setDataElementEditPrev((prevState) => {
          const newPrev = { ...prevState };
          tab.columns.forEach((col) => {
            delete newPrev[col.id];
          });
          return newPrev;
        });
      }

      return updatedSections;
    });
  };

  const addSection = () => {
    setIngestionSections((prev) => [...prev, createNewIngestionSection()]);
  };

  const removeSection = (sectionId) => {
    setIngestionSections((prev) => {
      const sectionToRemove = prev.find((s) => s.id === sectionId);
      
      // Clean up edit state for all columns in the deleted section
      if (sectionToRemove) {
        setDataElementEditState((prevState) => {
          const newState = { ...prevState };
          sectionToRemove.tabs.forEach((tab) => {
            tab.columns.forEach((col) => {
              delete newState[col.id];
            });
          });
          return newState;
        });
        setDataElementEditPrev((prevState) => {
          const newPrev = { ...prevState };
          sectionToRemove.tabs.forEach((tab) => {
            tab.columns.forEach((col) => {
              delete newPrev[col.id];
            });
          });
          return newPrev;
        });
      }

      // Saved sections are kept and flagged so the backend can delete them; unsaved ones are dropped
      return sectionToRemove?.ingestionConfigId
        ? prev.map((s) => (s.id === sectionId ? { ...s, markForDelete: true } : s))
        : prev.filter((s) => s.id !== sectionId);
    });
  };

  const handleDataElementEditClick = (columnId, col) => {
    setDataElementEditPrev((prev) => ({
      ...prev,
      [columnId]: {
        dataElementId: col.dataElementId || null,
        dataElement: col.dataElement || "",
        dataElementLabel: col.dataElementLabel || "",
      },
    }));
    setDataElementEditState((prev) => ({ ...prev, [columnId]: true }));
  };

  const handleDataElementSave = (columnId) => {
    setDataElementEditState((prev) => ({ ...prev, [columnId]: false }));
  };

  const handleDataElementCancel = (sectionId, tabId, columnId) => {
    const prevValue = dataElementEditPrev[columnId];
    if (prevValue) {
      handleDataElementChange(
        sectionId,
        tabId,
        columnId,
        prevValue.dataElementId,
        prevValue.dataElement,
        prevValue.dataElementLabel
      );
    }
    setDataElementEditState((prev) => ({ ...prev, [columnId]: false }));
  };

  const isAnyDataElementBeingEdited = () => {
    return Object.values(dataElementEditState).some(value => value === true);
  };

  const isSectionComplete = (section) => {
    if (section.markForDelete) return true;
    if (!section.category || !section.ingestThrough) return false;
    // Filter out tabs where all columns are deleted
    const activeTabs = section.tabs.filter((tab) => tab.columns.some((col) => !col.markForDelete));
    return activeTabs.every((tab) => {
      if (section.fileHasMultipleTabs === "Yes" && !tab.tabName.trim()) return false;
      return tab.columns
        .filter((col) => !col.markForDelete)
        .every(
          (col) => col.columnName.trim() && col.fieldType && col.dataElementId && col.ingestion && !col.columnNameError
        );
    });
  };

  const isTabComplete = (section, tab) => {
    if (section.fileHasMultipleTabs === "Yes" && !tab.tabName.trim()) return false;
    return tab.columns
      .filter((col) => !col.markForDelete)
      .every(
        (col) => col.columnName.trim() && col.fieldType && col.dataElementId && col.ingestion && !col.columnNameError
      );
  };

  const getAvailableDataElements = (section, tab, column) => {
    // Find data elements for the current category from API data
    const categoryData = dataElements.find(
      (item) => item.category === section.category
    );
    const allElements = categoryData?.dataElements || [];
    
    if (column.fieldType === "Chain of custody") {
      // Chain of custody: Only disable elements from Chain of custody in SAME tab (not other tabs)
      const selectedByChainInSameTab = tab.columns
        .filter((col) => !col.markForDelete && col.id !== column.id && col.fieldType === "Chain of custody")
        .map((col) => col.dataElementId)
        .filter(Boolean);
      
      return allElements
        .filter((el) => !el.markForDelete)
        .map((el) => ({
          value: el.dataElementId,
          label: el.dataElementLabel,
          dataElementKey: el.dataElementKey,
          dataElementId: el.dataElementId,
          disabled: selectedByChainInSameTab.includes(el.dataElementId),
        }));
    }
    
    if (column.fieldType === "First Choice") {
      // First Choice: Disable if used by:
      // 1. Other First Choice in same tab
      // 2. Chain of Custody in same tab
      // 3. First Choice in other tabs (from all sections with same category)
      // BUT can use Chain of Custody from other tabs
      
      const selectedByFirstChoiceInSameTab = tab.columns
        .filter((col) => !col.markForDelete && col.id !== column.id && col.fieldType === "First Choice")
        .map((col) => col.dataElementId)
        .filter(Boolean);
      
      const selectedByChainInSameTab = tab.columns
        .filter((col) => !col.markForDelete && col.fieldType === "Chain of custody")
        .map((col) => col.dataElementId)
        .filter(Boolean);
      
      const selectedByFirstChoiceInOtherTabs = ingestionSections
        .filter((s) => !s.markForDelete && s.category === section.category) // All sections with same category
        .flatMap((s) => s.tabs)
        .filter((t) => t.id !== tab.id) // Exclude current tab
        .flatMap((t) => t.columns)
        .filter((col) => !col.markForDelete && col.fieldType === "First Choice")
        .map((col) => col.dataElementId)
        .filter(Boolean);
      
      const disabledElements = [...selectedByFirstChoiceInSameTab, ...selectedByChainInSameTab, ...selectedByFirstChoiceInOtherTabs];
      
      return allElements
        .filter((el) => !el.markForDelete)
        .map((el) => ({
          value: el.dataElementId,
          label: el.dataElementLabel,
          dataElementKey: el.dataElementKey,
          dataElementId: el.dataElementId,
          disabled: disabledElements.includes(el.dataElementId),
        }));
    }
    
    if (column.fieldType === "Second Choice") {
      // Second Choice: Show elements selected by First Choice OR Chain of Custody in the same section

      // Get all First Choice elements from the same section
      const selectedByFirstChoiceInSameSection = section.tabs
        .flatMap((t) => t.columns)
        .filter((col) => !col.markForDelete && col.fieldType === "First Choice")
        .map((col) => col.dataElementId)
        .filter(Boolean);

      // Get Chain of Custody elements from the same section
      const selectedByChainInSameSection = section.tabs
        .flatMap((t) => t.columns)
        .filter((col) => !col.markForDelete && col.fieldType === "Chain of custody")
        .map((col) => col.dataElementId)
        .filter(Boolean);

      // Combined pool: First Choice + Chain of Custody from same section
      const availablePool = [...new Set([...selectedByFirstChoiceInSameSection, ...selectedByChainInSameSection])];

      // Disable elements already picked by other Second Choice columns in the same tab
      const selectedBySecondChoiceInSameTab = tab.columns
        .filter((col) => !col.markForDelete && col.id !== column.id && col.fieldType === "Second Choice")
        .map((col) => col.dataElementId)
        .filter(Boolean);

      // Filter to show ONLY First Choice and Chain of Custody elements from same section
      return allElements
        .filter((el) => !el.markForDelete)
        .filter((el) => availablePool.includes(el.dataElementId))
        .map((el) => ({
          value: el.dataElementId,
          label: el.dataElementLabel,
          dataElementKey: el.dataElementKey,
          dataElementId: el.dataElementId,
          disabled: selectedBySecondChoiceInSameTab.includes(el.dataElementId),
        }));
    }
    
    // Default: return all elements
    return allElements
      .filter((el) => !el.markForDelete)
      .map((el) => ({
        value: el.dataElementId,
        label: el.dataElementLabel,
        dataElementKey: el.dataElementKey,
        dataElementId: el.dataElementId,
        disabled: false,
      }));
  };

  const isChainOfCustodyUsed = (tab, currentColumnId) => {
    return tab.columns.some(
      (col) =>
        col.id !== currentColumnId && col.fieldType === "Chain of custody"
    );
  };

  return (
    <div>
      {ingestionSections.map((section) => {
        if (section.markForDelete) return null;
        const showTabColumn = section.fileHasMultipleTabs === "Yes";
        return (
          <div key={section.id} style={{ marginBottom: 40 }}>
            <Grid container spacing={3}>
              <Grid item xs={12}>
                <FormControl className={classes.formField}>
                  <Typography component="label">
                    Category{" "}
                    {!readOnly && <span style={{ color: "red" }}>*</span>}
                  </Typography>
                  <div style={{ display: "flex", alignItems: "center", gap: 8 }}>
                  {readOnly ? (
                    <Typography>{section.category || "N/A"}</Typography>
                  ) : (
                    <Select
                      value={section.category}
                      onChange={(e) =>
                        handleSectionFieldChange(
                          section.id,
                          "category",
                          e.target.value
                        )
                      }
                      variant="outlined"
                      fullWidth
                      displayEmpty
                      style={commonInlineStyles.input}
                      inputProps={commonInlineStyles.inputProps}
                    >
                      <MenuItem value="" disabled>
                        Select from the list
                      </MenuItem>
                      {ingestionCategoryOptions.map((opt) => (
                        <MenuItem key={opt} value={opt}>
                          {opt}
                        </MenuItem>
                      ))}
                    </Select>
                  )}
                  {!readOnly && ingestionSections.filter((s) => !s.markForDelete).length > 1 && (
                    <IconButton
                      size="small"
                      onClick={() => removeSection(section.id)}
                      style={{ marginLeft: 4 }}
                    >
                      <DeleteOutlineIcon
                        fontSize="small"
                        style={{ color: "#d32f2f" }}
                      />
                    </IconButton>
                  )}
                  </div>
                </FormControl>
              </Grid>
            </Grid>
            <Grid container spacing={3}>
              <Grid item xs={12} sm={6}>
                <FormControl className={classes.formField}>
                  <Typography component="label">
                    Ingest through{" "}
                    {!readOnly && <span style={{ color: "red" }}>*</span>}
                  </Typography>
                  {readOnly ? (
                    <Typography>
                      {section.ingestThrough || "N/A"}
                    </Typography>
                  ) : (
                    <Select
                      value={section.ingestThrough}
                      onChange={(e) =>
                        handleSectionFieldChange(
                          section.id,
                          "ingestThrough",
                          e.target.value
                        )
                      }
                      variant="outlined"
                      fullWidth
                      displayEmpty
                      style={commonInlineStyles.input}
                      inputProps={commonInlineStyles.inputProps}
                    >
                      <MenuItem value="" disabled>
                        Select from the list
                      </MenuItem>
                      {ingestThroughOptions.map((opt) => (
                        <MenuItem
                          key={opt.value}
                          value={opt.value}
                          disabled={opt.disabled}
                        >
                          {opt.value}
                        </MenuItem>
                      ))}
                    </Select>
                  )}
                </FormControl>
              </Grid>
              <Grid item xs={12} sm={6}>
                <FormControl className={classes.formField}>
                  <Typography component="label">
                    File has multiple tabs{" "}
                    {!readOnly && <span style={{ color: "red" }}>*</span>}
                  </Typography>
                  {readOnly ? (
                    <Typography>
                      {section.fileHasMultipleTabs || "N/A"}
                    </Typography>
                  ) : (
                    <Select
                      value={section.fileHasMultipleTabs}
                      onChange={(e) =>
                        handleSectionFieldChange(
                          section.id,
                          "fileHasMultipleTabs",
                          e.target.value
                        )
                      }
                      variant="outlined"
                      fullWidth
                      displayEmpty
                      style={commonInlineStyles.input}
                      inputProps={commonInlineStyles.inputProps}
                    >
                      <MenuItem value="Yes">Yes</MenuItem>
                      <MenuItem value="No">No</MenuItem>
                    </Select>
                  )}
                </FormControl>
              </Grid>
            </Grid>

            <TableContainer component={Paper} className={classes.table}>
              <Table>
                <TableHead className={classes.tableHead}>
                  <TableRow>
                    {showTabColumn && (
                      <TableCell className={classes.tableCell} style={{ width: "20%" }}>
                        <strong>
                          Tab Name{" "}
                          <span style={{ color: "red" }}>*</span>
                        </strong>
                      </TableCell>
                    )}
                    <TableCell className={classes.tableCell} style={{ width: "22%" }}>
                      <strong>
                        Column Name{" "}
                        <span style={{ color: "red" }}>*</span>
                      </strong>
                    </TableCell>
                    <TableCell className={classes.tableCell} style={{ width: "16%" }}>
                      <strong>
                        Field Type{" "}
                        <span style={{ color: "red" }}>*</span>
                      </strong>
                    </TableCell>
                    <TableCell className={classes.tableCell} style={{ width: "24%" }}>
                      <strong>
                        Data Elements{" "}
                        <span style={{ color: "red" }}>*</span>
                      </strong>
                    </TableCell>
                    <TableCell className={classes.tableCell} style={{ width: "18%" }}>
                      <strong>
                        Ingestion{" "}
                        <span style={{ color: "red" }}>*</span>
                      </strong>
                    </TableCell>
                  </TableRow>
                </TableHead>
                <TableBody>
                  {section.tabs
                    .filter((tab) => tab.columns.some((col) => !col.markForDelete))
                    .map((tab, tabIndex) => (
                    <React.Fragment key={tab.id}>
                      {tab.columns.filter((col) => !col.markForDelete).map((col, colIndex) => (
                        <TableRow key={col.id}>
                          {showTabColumn && colIndex === 0 && (
                            <TableCell
                              rowSpan={
                                tab.columns.filter((col) => !col.markForDelete).length + (!readOnly ? 1 : 0)
                              }
                              style={{ verticalAlign: "top" }}
                            >
                              {readOnly ? (
                                <Typography>
                                  {tab.tabName || "N/A"}
                                </Typography>
                              ) : (
                                <>
                                  <div style={{ display: "flex", alignItems: "center", gap: 4 }}>
                                    <TextField
                                      size="small"
                                      variant="outlined"
                                      value={tab.tabName}
                                      onChange={(e) =>
                                        handleTabNameChange(
                                          section.id,
                                          tab.id,
                                          e.target.value
                                        )
                                      }
                                      onBlur={() =>
                                        handleTabNameBlur(
                                          section.id,
                                          tab.id
                                        )
                                      }
                                      placeholder="Enter tab name"
                                      inputProps={{
                                        style: { fontSize: "14px" },
                                      }}
                                      style={{ flex: 1 }}
                                      disabled={isAnyDataElementBeingEdited()}
                                    />
                                    {section.tabs.filter((t) => t.columns.some((col) => !col.markForDelete)).length > 1 && (
                                      <IconButton
                                        size="small"
                                        onClick={() => removeTab(section.id, tab.id)}
                                        style={{ padding: 4 }}
                                        disabled={isAnyDataElementBeingEdited()}
                                      >
                                        <DeleteOutlineIcon
                                          fontSize="small"
                                          style={{ color: "#d32f2f" }}
                                        />
                                      </IconButton>
                                    )}
                                  </div>
                                  <Typography
                                    component="span"
                                    onClick={() => {
                                      if (!isTabComplete(section, tab) || isAnyDataElementBeingEdited()) return;
                                      addTab(section.id);
                                    }}
                                    style={{
                                      color: (isTabComplete(section, tab) && !isAnyDataElementBeingEdited()) ? "#ec6535" : "#ccc",
                                      cursor: (isTabComplete(section, tab) && !isAnyDataElementBeingEdited()) ? "pointer" : "not-allowed",
                                      marginTop: 8,
                                      fontSize: 14,
                                      display: "block",
                                    }}
                                  >
                                    + Add tab
                                  </Typography>
                                </>
                              )}
                            </TableCell>
                          )}
                          <TableCell>
                            <div
                              style={{
                                display: "flex",
                                alignItems: "center",
                              }}
                            >
                              {readOnly ? (
                                <Typography>
                                  {col.columnName || "N/A"}
                                </Typography>
                              ) : (
                                <>
                                  <TextField
                                    size="small"
                                    variant="outlined"
                                    value={col.columnName}
                                    onChange={(e) =>
                                      handleColumnChange(
                                        section.id,
                                        tab.id,
                                        col.id,
                                        "columnName",
                                        e.target.value
                                      )
                                    }
                                    onBlur={() =>
                                      handleColumnNameBlur(
                                        section.id,
                                        tab.id,
                                        col.id
                                      )
                                    }
                                    placeholder="Enter column name"
                                    inputProps={{
                                      style: { fontSize: "14px" },
                                    }}
                                    style={{ flexGrow: 1 }}
                                    disabled={isAnyDataElementBeingEdited()}
                                    error={col.columnNameError}
                                    helperText={col.columnNameError ? "Column name already exists in this tab" : ""}
                                  />
                                  {tab.columns.length > 1 && (
                                    <IconButton
                                      size="small"
                                      onClick={() =>
                                        removeColumn(
                                          section.id,
                                          tab.id,
                                          col.id
                                        )
                                      }
                                    >
                                      <DeleteOutlineIcon
                                        fontSize="small"
                                        style={{ color: "#d32f2f" }}
                                      />
                                    </IconButton>
                                  )}
                                </>
                              )}
                            </div>
                          </TableCell>
                          <TableCell>
                            <FormControl
                              variant="outlined"
                              size="small"
                              className={classes.mandatoryDropdown}
                            >
                              <Select
                                value={col.fieldType}
                                onChange={(e) =>
                                  handleColumnChange(
                                    section.id,
                                    tab.id,
                                    col.id,
                                    "fieldType",
                                    e.target.value
                                  )
                                }
                                disabled={readOnly || isAnyDataElementBeingEdited()}
                                displayEmpty
                              >
                                <MenuItem value="" disabled>
                                  Select
                                </MenuItem>
                                {ingestionFieldTypeOptions.map((opt) => (
                                  <MenuItem
                                    key={opt}
                                    value={opt}
                                    disabled={
                                      opt === "Chain of custody" &&
                                      isChainOfCustodyUsed(tab, col.id)
                                    }
                                  >
                                    {opt}
                                  </MenuItem>
                                ))}
                              </Select>
                            </FormControl>
                          </TableCell>
                          <TableCell>
                            {dataElementEditState[col.id] ? (
                              <div
                                style={{
                                  display: "flex",
                                  alignItems: "center",
                                }}
                              >
                                {isDataElementsLoading ? (
                                  <CircularProgress size={20} />
                                ) : (
                                  <Autocomplete
                                    options={getAvailableDataElements(
                                      section,
                                      tab,
                                      col
                                    )}
                                    getOptionLabel={(option) =>
                                      typeof option === "string"
                                        ? option
                                        : option.label || option.value || ""
                                    }
                                    getOptionDisabled={(option) => option.disabled}
                                    value={
                                      col.dataElementId
                                        ? getAvailableDataElements(section, tab, col).find(
                                            (opt) => opt.value === col.dataElementId
                                          ) || null
                                        : null
                                    }
                                    onChange={(e, newValue) => {
                                      if (newValue) {
                                        // Save id, key, and label in a single update
                                        handleDataElementChange(
                                          section.id,
                                          tab.id,
                                          col.id,
                                          newValue.dataElementId,
                                          newValue.dataElementKey,
                                          newValue.label
                                        );
                                      } else {
                                        handleDataElementChange(
                                          section.id,
                                          tab.id,
                                          col.id,
                                          null,
                                          "",
                                          ""
                                        );
                                      }
                                    }}
                                    getOptionSelected={(option, value) =>
                                      option.value === value.value
                                    }
                                    renderInput={(params) => (
                                      <TextField
                                        {...params}
                                        variant="outlined"
                                        size="small"
                                        placeholder="Search..."
                                      />
                                    )}
                                    style={{ minWidth: 200, flexGrow: 1 }}
                                    disableClearable
                                    openOnFocus
                                  />
                                )}
                                <IconButton
                                  size="small"
                                  onClick={() =>
                                    handleDataElementSave(col.id)
                                  }
                                  style={{ color: "green" }}
                                >
                                  <Check fontSize="small" />
                                </IconButton>
                                <IconButton
                                  size="small"
                                  onClick={() =>
                                    handleDataElementCancel(
                                      section.id,
                                      tab.id,
                                      col.id
                                    )
                                  }
                                  style={{ color: "#d32f2f" }}
                                >
                                  <CloseIcon fontSize="small" />
                                </IconButton>
                              </div>
                            ) : (
                              <div
                                style={{
                                  display: "flex",
                                  alignItems: "center",
                                }}
                              >
                                <span style={{ marginRight: 4, flexGrow: 1 }}>
                                  {col.dataElementLabel || col.dataElement || "N/A"}
                                </span>
                                {!readOnly && (
                                  <IconButton
                                    size="small"
                                    onClick={() =>
                                      handleDataElementEditClick(col.id, col)
                                    }
                                    disabled={isAnyDataElementBeingEdited() || !col.fieldType}
                                  >
                                    <EditIcon
                                      fontSize="small"
                                      style={{ color: (isAnyDataElementBeingEdited() || !col.fieldType) ? "#ccc" : "#ec6535" }}
                                    />
                                  </IconButton>
                                )}
                              </div>
                            )}
                          </TableCell>
                          <TableCell>
                            <FormControl
                              variant="outlined"
                              size="small"
                              className={classes.mandatoryDropdown}
                            >
                              <Select
                                value={col.ingestion}
                                onChange={(e) =>
                                  handleColumnChange(
                                    section.id,
                                    tab.id,
                                    col.id,
                                    "ingestion",
                                    e.target.value
                                  )
                                }
                                disabled={
                                  readOnly ||
                                  col.fieldType === "Chain of custody" ||
                                  isAnyDataElementBeingEdited()
                                }
                                displayEmpty
                              >
                                <MenuItem value="" disabled>
                                  Select
                                </MenuItem>
                                {ingestionValueOptions.map((opt) => (
                                  <MenuItem key={opt} value={opt}>
                                    {opt}
                                  </MenuItem>
                                ))}
                              </Select>
                            </FormControl>
                          </TableCell>
                        </TableRow>
                      ))}
                      {!readOnly && (
                        <TableRow>
                          <TableCell colSpan={4}>
                            <Typography
                              component="span"
                              onClick={() => {
                                if (!isTabComplete(section, tab) || isAnyDataElementBeingEdited()) return;
                                addColumn(section.id, tab.id);
                              }}
                              style={{
                                color: (isTabComplete(section, tab) && !isAnyDataElementBeingEdited()) ? "#ec6535" : "#ccc",
                                cursor: (isTabComplete(section, tab) && !isAnyDataElementBeingEdited()) ? "pointer" : "not-allowed",
                                fontSize: 14,
                              }}
                            >
                              + Add column
                            </Typography>
                          </TableCell>
                        </TableRow>
                      )}
                    </React.Fragment>
                  ))}
                </TableBody>
              </Table>
            </TableContainer>
          </div>
        );
      })}
      {!readOnly && (
        <Button
          variant="contained"
          onClick={() => {
            if (!ingestionSections.every(isSectionComplete)) return;
            addSection();
          }}
          disabled={!ingestionSections.every(isSectionComplete)}
          style={{
            backgroundColor: ingestionSections.every(isSectionComplete) ? "#ec6535" : "#ccc",
            color: "#fff",
            borderRadius: 6,
            marginTop: 16,
            textTransform: "none",
            fontWeight: 500,
          }}
        >
          + Add new section
        </Button>
      )}
    </div>
  );
};

const ShipmentConfigurations = ({
  updateStepData,
  handleNext,
  handleBack,
  formData,
  readOnly = false,
  isViewMode = false /* , isUpdateMode = false   */,
  selectedCMOFormData,
  originalVendorPlantDetails,
}) => {
  // Get the best available data source - prioritize direct API response
  const dataSource =
    originalVendorPlantDetails?.vendorPlantDetails?.vendorPlantDetails ||
    selectedCMOFormData?.vendorPlantDetails ||
    formData ||
    {};

  const [stepData, setStepData] = useState({
    ...formData,
    siteNameFromReport:
      dataSource?.siteNameFromReport || formData?.siteNameFromReport || "",
    cmoUsePOInterface: dataSource?.cmoToUsePOInterface
      ? dataSource.cmoToUsePOInterface
        ? "Yes"
        : "No"
      : formData?.cmoUsePOInterface || "",
    automateGoodsReceiptProcess:
      dataSource?.automateGRP !== undefined
        ? dataSource.automateGRP
          ? "Yes"
          : "No"
        : formData?.automateGoodsReceiptProcess || "",
    allocationOwnedBySponsor:
      typeof dataSource?.allocationOwnedBySponsor === "boolean"
        ? dataSource?.allocationOwnedBySponsor
          ? "Yes"
          : "No"
        : typeof formData?.allocationOwnedBySponsorr === "boolean"
        ? formData?.allocationOwnedBySponsor
          ? "Yes"
          : "No"
        : "",
    acceptanceLimitEarlyDelivery: formData?.acceptanceLimitEarlyDelivery || "",
    acceptanceLimitLaterDelivery: formData?.acceptanceLimitLaterDelivery || "",
    acceptanceLimitLessQuantity: formData?.acceptanceLimitLessQuantity || "",
    acceptanceLimitMoreQuantity: formData?.acceptanceLimitMoreQuantity || "",
    batchAllocationPdfRequired: formData?.batchAllocationPdfRequired || "Yes",
    pdfFieldTo: formData?.pdfFieldTo || "CMO Name",
    pdfFieldCC: formData?.pdfFieldCC || "All the users associated with the CMO, Brand and Product Type",
    pdfFieldSubject: formData?.pdfFieldSubject || "Batch Allocation done for Purchase Order 'PO Number' with Product 'BMS Product Code', Brand 'Brand Name'.",
    pdfFieldObjective: formData?.pdfFieldObjective || "The objective of this memo is to notify the 'CMO Name' of allocated (to be consumed) material/component batches for commercial manufacturing of Product 'BMS Product Code', Brand 'Brand name' based on Purchase Order 'PO Number' issued by 'Sponsor Name'.",
    // CMO Level Configurations (API shape: objectsToUseVendorLevelData / objectsToUseMfgPlantLevelData → mapped to internal UI shape)
    mosymphonyDisplayOptions: mapMosymphonyDisplayOptionsFromApi(
      formData?.mosymphonyDisplayOptions || dataSource?.mosymphonyDisplayOptions
    ),
    isIDOCRequired: dataSource?.isIDOCRequired !== undefined
      ? dataSource.isIDOCRequired ? "Yes" : "No"
      : typeof formData?.isIDOCRequired === "boolean"
        ? formData.isIDOCRequired ? "Yes" : "No"
        : formData?.isIDOCRequired || "",
    sourceProductDoMEqualsMaterial:
      dataSource?.domPresentOnDigitizationUI === true
        ? "Post Manufacturing Documents"
        : dataSource?.domPresentOnDigitizationUI === false
        ? "Inventory"
        : formData?.domPresentOnDigitizationUI === true
        ? "Post Manufacturing Documents"
        : formData?.domPresentOnDigitizationUI === false
        ? "Inventory"
        : formData?.sourceProductDoMEqualsMaterial || "",
  });


  const [documentTypesData, setdocumentTypesData] = useState([]);
  const [productTypesData, setproductTypesData] = useState([]);
  const [ingestionSections, setIngestionSections] = useState(() => {
    // Check for ingestionSections first (from step data)
    if (formData?.ingestionSections && Array.isArray(formData.ingestionSections) && formData.ingestionSections.length > 0) {
      return formData.ingestionSections;
    }
    // Then check for ingestionConfigurations (from API response)
    if (formData?.ingestionConfigurations && Array.isArray(formData.ingestionConfigurations) && formData.ingestionConfigurations.length > 0) {
      return mapIngestionConfigurationsFromApi(formData.ingestionConfigurations);
    }
    // Default empty section
    return [createNewIngestionSection()];
  });
  const [dataElements, setDataElements] = useState([]);
  const [isDataElementsLoading, setIsDataElementsLoading] = useState(false);
  useEffect(() => {
    setStepData({
      ...formData,
      siteNameFromReport: formData?.siteNameFromReport || "",
      cmoUsePOInterface: formData?.cmoUsePOInterface || "",
      automateGoodsReceiptProcess: formData?.automateGoodsReceiptProcess || "",
      allocationOwnedBySponsor:
        typeof formData?.allocationOwnedBySponsor === "boolean"
          ? formData?.allocationOwnedBySponsor
            ? "Yes"
            : "No"
          : formData?.allocationOwnedBySponsor || "",
      acceptanceLimitEarlyDelivery:
        formData?.acceptanceLimitEarlyDelivery || "",
      acceptanceLimitLaterDelivery:
        formData?.acceptanceLimitLaterDelivery || "",
      acceptanceLimitLessQuantity: formData?.acceptanceLimitLessQuantity || "",
      acceptanceLimitMoreQuantity: formData?.acceptanceLimitMoreQuantity || "",
      batchAllocationPdfRequired: formData?.batchAllocationPdfRequired || "Yes",
      pdfFieldTo: formData?.pdfFieldTo || "CMO Name",
      pdfFieldCC: formData?.pdfFieldCC || "All the users associated with the CMO, Brand and Product Type",
      pdfFieldSubject: formData?.pdfFieldSubject || "Batch Allocation done for Purchase Order 'PO Number' with Product 'BMS Product Code', Brand 'Brand Name'.",
      pdfFieldObjective: formData?.pdfFieldObjective || "The objective of this memo is to notify the 'CMO Name' of allocated (to be consumed) material/component batches for commercial manufacturing of Product 'BMS Product Code', Brand 'Brand name' based on Purchase Order 'PO Number' issued by 'Sponsor Name'.",
      // CMO Level Configurations (API shape → internal UI shape)
      mosymphonyDisplayOptions: mapMosymphonyDisplayOptionsFromApi(
        formData?.mosymphonyDisplayOptions
      ),
      isIDOCRequired: typeof formData?.isIDOCRequired === "boolean"
        ? formData.isIDOCRequired ? "Yes" : "No"
        : formData?.isIDOCRequired || "",
      sourceProductDoMEqualsMaterial:
        formData?.domPresentOnDigitizationUI === true
          ? "Post Manufacturing Documents"
          : formData?.domPresentOnDigitizationUI === false
          ? "Inventory"
          : formData?.sourceProductDoMEqualsMaterial || "",
    });
  }, [formData]);

  useEffect(() => {
    // Check for ingestionSections first (from step data)
    if (
      formData?.ingestionSections &&
      Array.isArray(formData.ingestionSections) &&
      formData.ingestionSections.length > 0
    ) {
      setIngestionSections(formData.ingestionSections);
    } 
    // Then check for ingestionConfigurations (from API response)
    else if (
      formData?.ingestionConfigurations &&
      Array.isArray(formData.ingestionConfigurations) &&
      formData.ingestionConfigurations.length > 0
    ) {
      setIngestionSections(mapIngestionConfigurationsFromApi(formData.ingestionConfigurations));
    }
  }, [formData?.ingestionSections, formData?.ingestionConfigurations]);

  // Enrich ingestion sections with dataElement keys when dataElements are loaded
  useEffect(() => {
    if (!dataElements || dataElements.length === 0 || !ingestionSections || ingestionSections.length === 0) {
      return;
    }

    // Check if any column is missing dataElementId
    const needsEnrichment = ingestionSections.some(section =>
      section.tabs.some(tab =>
        tab.columns.some(col => !col.dataElementId && (col.dataElement || col.dataElementLabel))
      )
    );

    if (!needsEnrichment) return;

    // Enrich sections with dataElement keys and IDs
    const enrichedSections = ingestionSections.map(section => {
      const categoryData = dataElements.find(item => item.category === section.category);
      if (!categoryData) return section;

      return {
        ...section,
        tabs: section.tabs.map(tab => ({
          ...tab,
          columns: tab.columns.map(col => {
            // Skip if dataElementId already exists, or if both dataElement and dataElementLabel are missing
            if (col.dataElementId || (!col.dataElement && !col.dataElementLabel)) return col;
            
            // Find dataElement by key or label
            const element = categoryData.dataElements.find(
              el => el.dataElementKey === col.dataElement || el.dataElementLabel === col.dataElementLabel
            );
            
            if (element) {
              return {
                ...col,
                dataElement: element.dataElementKey,
                dataElementId: element.dataElementId,
                dataElementLabel: element.dataElementLabel,
              };
            }
            return col;
          }),
        })),
      };
    });

    setIngestionSections(enrichedSections);
  }, [dataElements, formData?.ingestionConfigurations]);

  useEffect(() => {
    setStepData((prev) => ({
      ...prev,
      documentTypesList: documentTypesData,
      vendorProductTypeConfigs: productTypesData,
      ingestionSections: ingestionSections,
    }));
  }, [documentTypesData, productTypesData, ingestionSections]);

  /*
   * BCM-891: the rows the Product Type Configurations table shows, and its
   * change handler. Both are memoised so editing one dropdown re-renders that
   * row alone instead of every row -- the table sits in a very large component
   * that re-renders on any state change, and rebuilding every dropdown each
   * time was what made Yes/No feel slow.
   *
   * allocationPDFTitle is kept in step with artworkRequired here rather than
   * only at save time, so the Title column and the stored value can never
   * disagree.
   */
  /*
   * Every product type, not only the activated ones. The spec is explicit —
   * "The table has one row per product type" — and the same table has to show
   * the same rows on Add, View and Update, or a value set on one screen appears
   * against a different product type on another.
   */

  const handlePdfConfigChange = React.useCallback((productTypeID, field, value) => {
    setproductTypesData((prev) =>
      prev.map((row) =>
        row.productTypeID === productTypeID
          ? {
              ...row,
              [field]: value,
              allocationPDFTitle: allocationPdfTitle(
                field === "artworkRequired" ? value : row.artworkRequired
              ),
            }
          : row
      )
    );
  }, []);

  const [loading, setLoading] = useState(false);
  const [isDocLoading, setIsDocLoading] = useState(false);
  const [isProdLoading, setIsProdLoading] = useState(false);
  const [error, setError] = useState("");
  const [errors, setErrors] = useState({});
  const [submitted, setSubmitted] = useState(false);
  const [brandOwnerMosymphonyID, setBrandOwnerMosymphonyID] = useState(null);
  const [authDetails, setAuthDetails] = useState(null);

  const classes = useStyles();
  const API_BASE_URL = useApiBaseUrl(appUrl);
  const cmoDetailsResponse = JSON.parse(
    sessionStorage.getItem("cmoDetailsResponse")
  );
  const token = localStorage.getItem("authToken"); // or sessionStorage, or from a cookie

  // Determine if Manufacturing Plant Level options should be disabled
  // Disable only when: exactly 1 site with exactly 1 plant
  // Enable when: multiple sites OR 1 site with multiple plants
  const isPlantLevelDisabled = useMemo(() => {
    const cmoSites = formData?.cmoSites || [];
    
    // Filter out sites marked for deletion
    const activeSites = cmoSites.filter(
      (site) => !site?.siteDetails?.markForDelete
    );

    // If exactly 1 site, check plant count
    if (activeSites.length === 1) {
      const site = activeSites[0];
      const plants = site?.manufacturingPlantDataList || [];
      const activePlants = plants.filter(
        (plant) => !plant?.mfgPlantDetails?.markForDelete && !plant?.markForDelete
      );

      // Disable only if exactly 1 plant
      return activePlants.length === 1;
    }

    // Multiple sites or no sites → enable (return false)
    return false;
  }, [formData?.cmoSites]);

  useEffect(() => {
    if (token) {
      try {
        const base64Url = token.split(".")[1]; // Get payload
        const base64 = base64Url.replace(/-/g, "+").replace(/_/g, "/");
        const jsonPayload = decodeURIComponent(
          atob(base64)
            .split("")
            .map((c) => `%${("00" + c.charCodeAt(0).toString(16)).slice(-2)}`)
            .join("")
        );

        const payload = JSON.parse(jsonPayload);
        setBrandOwnerMosymphonyID(payload.organization_id);
        setAuthDetails(payload);
      } catch (e) {
        console.error("Invalid token", e);
      }
    }
  }, [token]);

  // Fetch data elements from API
  useEffect(() => {
    const fetchDataElements = async () => {
      if (!API_BASE_URL) return;
      
      setIsDataElementsLoading(true);
      try {
        const response = await axios.get(
          `${API_BASE_URL}/fetchDataElements`
        );
        if (response?.data?.status === 200 && response?.data?.data?.dataElementsList) {
          // Transform flat list into grouped structure by category
          const groupedData = response.data.data.dataElementsList.reduce((acc, element) => {
            const existingCategory = acc.find(item => item.category === element.category);
            if (existingCategory) {
              existingCategory.dataElements.push({
                dataElementId: element.dataElementId,
                dataElementKey: element.dataElementKey,
                dataElementLabel: element.dataElementLabel,
                markForDelete: element.markForDelete
              });
            } else {
              acc.push({
                category: element.category,
                dataElements: [{
                  dataElementId: element.dataElementId,
                  dataElementKey: element.dataElementKey,
                  dataElementLabel: element.dataElementLabel,
                  markForDelete: element.markForDelete
                }]
              });
            }
            return acc;
          }, []);
          setDataElements(groupedData);
        }
      } catch (error) {
        console.error("Error fetching data elements:", error);
      } finally {
        setIsDataElementsLoading(false);
      }
    };

    fetchDataElements();
  }, [API_BASE_URL]);

  // Removed duplicate useEffect - now using only view CMO details data

  useEffect(() => {
    let isMounted = true;

    if (
      formData?.cmoDocumentTypesList &&
      Array.isArray(formData.cmoDocumentTypesList) &&
      formData.cmoDocumentTypesList.length > 0
    ) {
      const formattedData = formData.cmoDocumentTypesList.map((doc) => ({
        documentTypeID: doc.documentTypeID,
        documentTypeName: doc.documentTypeName,
        activated: doc.activated,
        newDocumentTypeName: doc.newDocumentTypeName || "",
        documentType: doc.documentType,
        documentCategoryID: doc.documentCategoryID,
        documentCategoryName: doc.documentCategoryName || "", // Ensure it's not undefined
        mandatoryInProcessWorkflow: doc.mandatoryInProcessWorkflow || false,
      }));

      if (isMounted) {
        setdocumentTypesData((prev) =>
          JSON.stringify(prev) !== JSON.stringify(formattedData)
            ? formattedData
            : prev
        );
        setIsDocLoading(false);
      }
      return;
    }

    //Priority 2: Use existing document types list if available (fallback)
    const existingData = formData?.documentTypesList;
    if (
      existingData &&
      Array.isArray(existingData) &&
      existingData.length > 0
    ) {
      // Fetch fresh data from API and merge with existing data
      const fetchAndMergeDocumentTypes = async () => {
        try {
          const productConfig = true;
          const response = await axios.get(
            `${API_BASE_URL}/fetchDocumentTypes/${productConfig}`
          );
          if (response.data.data.documentTypesList && isMounted) {
            const fetchedData = response.data.data.documentTypesList.map(
              (doc) => ({
                documentTypeID: doc.documentTypeID,
                documentTypeName: doc.documentTypeName,
                activated: false,
                newDocumentTypeName: doc.newDocumentTypeName || "",
                documentType: doc.documentType,
                documentCategoryID: doc.documentCategoryID,
                documentCategoryName: doc.documentCategoryName || "",
                // mandatoryInProcessWorkflow: doc.mandatoryInProcessWorkflow || false
              })
            );

            // Merge fetched data with existing data by documentTypeID while preserving original order
            const mergedData = existingData.map((existingDoc) => {
              const fetchedDoc = fetchedData.find(
                (fetched) =>
                  fetched.documentTypeID === existingDoc.documentTypeID
              );

              if (fetchedDoc) {
                // Update with fresh data but preserve user modifications and original order
                return {
                  ...fetchedDoc,
                  activated: existingDoc.activated,
                  newDocumentTypeName:
                    existingDoc.newDocumentTypeName !== "NA"
                      ? existingDoc.newDocumentTypeName
                      : fetchedDoc.newDocumentTypeName,
                  mandatoryInProcessWorkflow:
                    existingDoc.mandatoryInProcessWorkflow,
                };
              }

              // If document not found in fetched data, keep the existing one
              return existingDoc;
            });

            // Add any new documents from fetched data that weren't in existing data
            const existingIds = existingData.map((doc) => doc.documentTypeID);
            const newDocuments = fetchedData.filter(
              (fetchedDoc) => !existingIds.includes(fetchedDoc.documentTypeID)
            );

            const finalMergedData = [...mergedData, ...newDocuments];

            if (isMounted) {
              setdocumentTypesData(finalMergedData);
            }
          }
        } catch (error) {
          console.error("Error fetching document types:", error);
          // Fallback to existing data if API fails
          if (isMounted) {
            setdocumentTypesData(existingData);
          }
        } finally {
          if (isMounted) setIsDocLoading(false);
        }
      };

      fetchAndMergeDocumentTypes();
      return;
    }

    // Priority 3: Fallback to separate API call only if no data available
    if (isMounted) {
      setIsDocLoading(true);
      const fetchDocumentTypes = async () => {
        try {
          const productConfig = true;
          const response = await axios.get(
            `${API_BASE_URL}/fetchDocumentTypes/${productConfig}`
          );
          if (response.data.data.documentTypesList) {
            const defaultData = response.data.data.documentTypesList.map(
              (doc) => ({
                documentTypeID: doc.documentTypeID,
                documentTypeName: doc.documentTypeName,
                activated: doc.activated,
                newDocumentTypeName: doc.newDocumentTypeName || "",
                documentType: doc.documentType,
                documentCategoryID: doc.documentCategoryID,
                documentCategoryName: doc.documentCategoryName || "",
                // showInViewGoodsReceipt: doc.showInViewGoodsReceipt ?? false, // Default to false
                // mandatoryInProcessFlow1: doc.mandatoryInProcessFlow1 ?? false, // Default to false
                // mandatoryInProcessFlow4: doc.mandatoryInProcessFlow4 ?? false, // Default to false
              })
            );

            if (isMounted) {
              setdocumentTypesData(defaultData);
            }
          }
        } catch (error) {
          console.error("Error fetching document types:", error);
        } finally {
          if (isMounted) setIsDocLoading(false);
        }
      };

      fetchDocumentTypes();
    }
  }, [
    formData?.cmoDocumentTypesList,
    formData?.documentTypesList,
    API_BASE_URL,
  ]);

  useEffect(() => {
    let isMounted = true;

    //console.log(formData);
    //console.log(".............................");
    // if (
    //   formData?.vendorProductTypeConfigs &&
    //   Array.isArray(formData.vendorProductTypeConfigs) &&
    //   formData.vendorProductTypeConfigs.length > 0
    // ) {
    //   const formattedData = formData.vendorProductTypeConfigs.map((doc) => ({
    //     productTypeID: doc.productTypeID,
    //     productTypeName: doc.productTypeName,
    //     activated: true,
    //     consumptionDataReqdForIBDGRN:
    //       typeof doc.consumptionDataReqdForIBDGRN === "boolean"
    //         ? doc.consumptionDataReqdForIBDGRN
    //         : "NA",
    //     uploadConsumptionData:
    //       typeof doc.uploadConsumptionData === "boolean"
    //         ? doc.uploadConsumptionData
    //         : "NA",
    //     consumptionSameAsAllocation:
    //       typeof doc.consumptionSameAsAllocation === "boolean"
    //         ? doc.consumptionSameAsAllocation
    //         : "NA",
    //     manuallyAddConsumptionData:
    //       typeof doc.manuallyAddConsumptionData === "boolean"
    //         ? doc.manuallyAddConsumptionData
    //         : "NA",
    //     // consumptionDataReqdForIBDGRN: [1, 2].includes(doc.productTypeID)
    //     //   ? false
    //     //   : doc.productType === "Default"
    //     //   ? true
    //     //   : "NA",
    //     // uploadConsumptionData:
    //     //   ![1, 2].includes(doc.productTypeID) === true &&
    //     //   doc.productType === "Default"
    //     //     ? true
    //     //     : "NA",
    //     // consumptionSameAsAllocation: "NA",
    //     // manuallyAddConsumptionData: "NA",
    //   }));

    //   if (isMounted) {
    //     setproductTypesData((prev) =>
    //       JSON.stringify(prev) !== JSON.stringify(formattedData)
    //         ? formattedData
    //         : prev
    //     );
    //     setIsProdLoading(false);
    //   }
    //   return;
    // }

    const existingData = formData?.vendorProductTypeConfigs;
    if (
      existingData &&
      Array.isArray(existingData) &&
      existingData.length > 0
    ) {
      // Fetch fresh data from API and merge with existing data
      const fetchAndMergeProductTypes = async () => {
        try {
          const productConfig = true;
          const response = await axios.get(
            `${API_BASE_URL}/fetchProductTypes/${productConfig}`
          );
          if (response.data.data.productTypeList && isMounted) {
            const fetchedData = response.data.data.productTypeList.map(
              (doc) => ({
                productTypeID: doc.productTypeID,
                productTypeName: doc.productTypeName,
                activated: true,
                consumptionDataReqdForIBDGRN: [1, 2].includes(doc.productTypeID)
                  ? false
                  : doc.productType === "Default"
                  ? true
                  : false,
                  // : "NA",
                uploadConsumptionData:
                  ![1, 2].includes(doc.productTypeID) === true &&
                  doc.productType === "Default"
                    ? true
                    : false,
                    // : "NA",
                    consumptionSameAsAllocation: false,
                manuallyAddConsumptionData: false,
                expiryDateProvided: true,
                // BCM-891: defaults for a product type with no saved
                // configuration, so the dropdowns read false rather than
                // undefined. A saved value overrides these in the merge.
                documentIDReqd: false,
                artworkRequired: false,
                allocationApprovalReqd: false,
                allocationPDFTitle: "Allocation Memo",
                consumedQtyInfoPresent: null,
                consumedQtyMappedTo: null,
                // consumptionSameAsAllocation: "NA",
                // manuallyAddConsumptionData: "NA",
                earlyDateVarianceLimit: null,
                earlyPODateUpdateInERP: null,
                earlyDateUpdateType: null,
                earlyDateWarningMessageRequired: null,
                laterDateVarianceLimit: null,
                laterPODateUpdateInERP: null,
                laterDateUpdateType: null,
                laterDateWarningMessageRequired: null,
                consumedQtyVarianceLimitPercentage: null,
                consumedQtyVarianceApprovalRequired: null,
                consumedQtyVarianceWarningMessageRequired: null,
                lotMismatchApprovalRequired: null,
                lotMismatchWarningMessageRequired: null,
                lessProducedQtyVarianceLimitPercentage: null,
                lessProducedQtyUpdateInERP: null,
                lessProducedQtyUpdateType: null,
                lessProducedQtyWarningMessageRequired: null,
                moreProducedQtyVarianceLimitPercentage: null,
                moreProducedQtyUpdateInERP: null,
                moreProducedQtyUpdateType: null,
                moreProducedQtyWarningMessageRequired: null,
              })
            );

            const mergedData = existingData.map((existingDoc) => {
              const fetchedDoc = fetchedData.find(
                (fetched) => fetched.productTypeID === existingDoc.productTypeID
              );

              if (fetchedDoc) {
                return {
                  ...fetchedDoc,
                  activated: existingDoc.activated,
                  consumptionDataReqdForIBDGRN:
                    typeof existingDoc.consumptionDataReqdForIBDGRN ===
                    "boolean"
                      ? existingDoc.consumptionDataReqdForIBDGRN
                      : false,
                      // : "NA",
                  uploadConsumptionData:
                    typeof existingDoc.uploadConsumptionData === "boolean"
                      ? existingDoc.uploadConsumptionData
                      : false,
                      // : "NA",
                  consumptionSameAsAllocation:
                    typeof existingDoc.consumptionSameAsAllocation === "boolean"
                      ? existingDoc.consumptionSameAsAllocation
                      : false,
                      // : "NA",
                  manuallyAddConsumptionData:
                    typeof existingDoc.manuallyAddConsumptionData === "boolean"
                      ? existingDoc.manuallyAddConsumptionData
                      : false,
                      // : "NA",
                  consumedQtyInfoPresent:
                    existingDoc.consumedQtyInfoPresent === true || existingDoc.consumedQtyInfoPresent === false
                      ? existingDoc.consumedQtyInfoPresent
                      : null,
                  consumedQtyMappedTo:
                    ["onHandQty", "bomQty"].includes(existingDoc.consumedQtyMappedTo)
                      ? existingDoc.consumedQtyMappedTo
                      : null,
                  expiryDateProvided:
                    typeof existingDoc.expiryDateProvided === "boolean"
                      ? existingDoc.expiryDateProvided
                      : true,
                  // BCM-891: carried across from the saved row. fetchedDoc is the
                  // product-type master and never holds these, so omitting them
                  // here left them undefined on every re-mount of this step —
                  // which is why Review & Add showed every row as "No" however
                  // they had just been set.
                  documentIDReqd:
                    typeof existingDoc.documentIDReqd === "boolean"
                      ? existingDoc.documentIDReqd
                      : false,
                  artworkRequired:
                    typeof existingDoc.artworkRequired === "boolean"
                      ? existingDoc.artworkRequired
                      : false,
                  allocationApprovalReqd:
                    typeof existingDoc.allocationApprovalReqd === "boolean"
                      ? existingDoc.allocationApprovalReqd
                      : false,
                  // Derived from this row's own artworkRequired, so the title can
                  // never disagree with the dropdown beside it.
                  allocationPDFTitle:
                    existingDoc.artworkRequired === true
                      ? "Allocation and Artwork Memo"
                      : "Allocation Memo",
                  earlyDateVarianceLimit: existingDoc.earlyDateVarianceLimit ?? null,
                  earlyPODateUpdateInERP: typeof existingDoc.earlyPODateUpdateInERP === "boolean" ? existingDoc.earlyPODateUpdateInERP : null,
                  earlyDateUpdateType: existingDoc.earlyDateUpdateType || null,
                  earlyDateWarningMessageRequired: typeof existingDoc.earlyDateWarningMessageRequired === "boolean" ? existingDoc.earlyDateWarningMessageRequired : null,
                  laterDateVarianceLimit: existingDoc.laterDateVarianceLimit ?? null,
                  laterPODateUpdateInERP: typeof existingDoc.laterPODateUpdateInERP === "boolean" ? existingDoc.laterPODateUpdateInERP : null,
                  laterDateUpdateType: existingDoc.laterDateUpdateType || null,
                  laterDateWarningMessageRequired: typeof existingDoc.laterDateWarningMessageRequired === "boolean" ? existingDoc.laterDateWarningMessageRequired : null,
                  consumedQtyVarianceLimitPercentage: existingDoc.consumedQtyVarianceLimitPercentage ?? null,
                  consumedQtyVarianceApprovalRequired: typeof existingDoc.consumedQtyVarianceApprovalRequired === "boolean" ? existingDoc.consumedQtyVarianceApprovalRequired : null,
                  consumedQtyVarianceWarningMessageRequired: typeof existingDoc.consumedQtyVarianceWarningMessageRequired === "boolean" ? existingDoc.consumedQtyVarianceWarningMessageRequired : null,
                  lotMismatchApprovalRequired: typeof existingDoc.lotMismatchApprovalRequired === "boolean" ? existingDoc.lotMismatchApprovalRequired : null,
                  lotMismatchWarningMessageRequired: typeof existingDoc.lotMismatchWarningMessageRequired === "boolean" ? existingDoc.lotMismatchWarningMessageRequired : null,
                  lessProducedQtyVarianceLimitPercentage: existingDoc.lessProducedQtyVarianceLimitPercentage ?? null,
                  lessProducedQtyUpdateInERP: typeof existingDoc.lessProducedQtyUpdateInERP === "boolean" ? existingDoc.lessProducedQtyUpdateInERP : null,
                  lessProducedQtyUpdateType: existingDoc.lessProducedQtyUpdateType || null,
                  lessProducedQtyWarningMessageRequired: typeof existingDoc.lessProducedQtyWarningMessageRequired === "boolean" ? existingDoc.lessProducedQtyWarningMessageRequired : null,
                  moreProducedQtyVarianceLimitPercentage: existingDoc.moreProducedQtyVarianceLimitPercentage ?? null,
                  moreProducedQtyUpdateInERP: typeof existingDoc.moreProducedQtyUpdateInERP === "boolean" ? existingDoc.moreProducedQtyUpdateInERP : null,
                  moreProducedQtyUpdateType: existingDoc.moreProducedQtyUpdateType || null,
                  moreProducedQtyWarningMessageRequired: typeof existingDoc.moreProducedQtyWarningMessageRequired === "boolean" ? existingDoc.moreProducedQtyWarningMessageRequired : null,
                };
              }

              // If document not found in fetched data, keep the existing one
              return existingDoc;
            });

            // Add any new documents from fetched data that weren't in existing data
            const existingIds = existingData.map((doc) => doc.productTypeID);
            const newProducts = fetchedData.filter(
              (fetchedDoc) => !existingIds.includes(fetchedDoc.productTypeID)
            );

            const finalMergedData = [...mergedData, ...newProducts];

            if (isMounted) {
              setproductTypesData(finalMergedData);
            }
          }
        } catch (error) {
          console.error("Error fetching document types:", error);
          // Fallback to existing data if API fails
          if (isMounted) {
            setproductTypesData(existingData);
          }
        } finally {
          if (isMounted) setIsProdLoading(false);
        }
      };

      fetchAndMergeProductTypes();
      return;
    }

    if (isMounted && !readOnly) {
      setIsProdLoading(true);
      const fetchProductTypes = async () => {
        try {
          const productConfig = true;
          const response = await axios.get(
            `${API_BASE_URL}/fetchProductTypes/${productConfig}`
          );
          if (response.data.data.productTypeList) {
            const defaultData = response.data.data.productTypeList.map(
              (doc) => ({
                productTypeID: doc.productTypeID,
                productTypeName: doc.productTypeName,
                activated: true,
                consumptionDataReqdForIBDGRN: [1, 2].includes(doc.productTypeID)
                  ? false
                  : doc.productType === "Default"
                  ? true
                  : false,
                  // : "NA",
                uploadConsumptionData:
                  ![1, 2].includes(doc.productTypeID) === true &&
                  doc.productType === "Default"
                    ? true
                    : false,
                    // : "NA",
                consumptionSameAsAllocation: false,
                manuallyAddConsumptionData: false,
                expiryDateProvided: true,
                // BCM-891: defaults for a product type with no saved
                // configuration, so the dropdowns read false rather than
                // undefined. A saved value overrides these in the merge.
                documentIDReqd: false,
                artworkRequired: false,
                allocationApprovalReqd: false,
                allocationPDFTitle: "Allocation Memo",
                consumedQtyInfoPresent: null,
                consumedQtyMappedTo: null,
                // consumptionSameAsAllocation: "NA",
                // manuallyAddConsumptionData: "NA",
                earlyDateVarianceLimit: 15,
                earlyPODateUpdateInERP: false,
                earlyDateUpdateType: null,
                earlyDateWarningMessageRequired: true,
                laterDateVarianceLimit: 5,
                laterPODateUpdateInERP: false,
                laterDateUpdateType: null,
                laterDateWarningMessageRequired: true,
                consumedQtyVarianceLimitPercentage: 10,
                consumedQtyVarianceApprovalRequired: false,
                consumedQtyVarianceWarningMessageRequired: true,
                lotMismatchApprovalRequired: true,
                lotMismatchWarningMessageRequired: false,
                lessProducedQtyVarianceLimitPercentage: 10,
                lessProducedQtyUpdateInERP: false,
                lessProducedQtyUpdateType: null,
                lessProducedQtyWarningMessageRequired: true,
                moreProducedQtyVarianceLimitPercentage: 10,
                moreProducedQtyUpdateInERP: true,
                moreProducedQtyUpdateType: "Automatic without approval",
                moreProducedQtyWarningMessageRequired: true,
              })
            );

            if (isMounted) {
              setproductTypesData(defaultData);
            }
          }
        } catch (error) {
          console.error("Error fetching product types:", error);
        } finally {
          if (isMounted) setIsProdLoading(false);
        }
      };

      fetchProductTypes();
    }
  }, [
    formData?.vendorProductTypeConfigs,
    formData?.productTypesList,
    API_BASE_URL,
  ]);

  const handleFieldChange = (e) => {
    const { name, value } = e.target;
    setStepData((prev) => ({ ...prev, [name]: value }));
    if (errors[name]) {
      setErrors((prev) => ({ ...prev, [name]: "" }));
    }
  };

  const handleMosymphonyDisplayChange = (category, level) => {
    setStepData((prev) => ({
      ...prev,
      mosymphonyDisplayOptions: {
        ...prev.mosymphonyDisplayOptions,
        [category]: level,
      },
    }));
  };

  const isSectionComplete = (section) => {
    if (section.markForDelete) return true;
    if (!section.category || !section.ingestThrough) return false;
    // Filter out tabs where all columns are deleted
    const activeTabs = section.tabs.filter((tab) => tab.columns.some((col) => !col.markForDelete));
    return activeTabs.every((tab) => {
      if (section.fileHasMultipleTabs === "Yes" && !tab.tabName.trim()) return false;
      return tab.columns
        .filter((col) => !col.markForDelete)
        .every(
          (col) => col.columnName.trim() && col.fieldType && col.dataElement && col.ingestion && !col.columnNameError
        );
    });
  };

  const areAllIngestionSectionsComplete = () => {
    return ingestionSections.some((s) => !s.markForDelete) && ingestionSections.every(isSectionComplete);
  };

  const validate = () => {
    const newErrors = {};
    let isValid = true;
    

    
    if (!stepData.allowMultipleBatches) {
      newErrors.allowMultipleBatches = "This field is required.";
      isValid = false;
    }
    if (
      !stepData.shipmentDuration ||
      String(stepData.shipmentDuration).trim() === ""
    ) {
      newErrors.shipmentDuration = "This field is required.";
      isValid = false;
    } else if (!/^[1-9][0-9]*$/.test(String(stepData.shipmentDuration))) {
      newErrors.shipmentDuration = "Please enter a valid positive number.";
      isValid = false;
    }
    if (!stepData.automateGoodsReceiptProcess) {
      newErrors.automateGoodsReceiptProcess = "This field is required.";
      isValid = false;
    }
    if (!stepData.allocationOwnedBySponsor) {
      newErrors.allocationOwnedBySponsor = "This field is required.";
      isValid = false;
    }

    if (!stepData.batchAllocationPdfRequired) {
      newErrors.batchAllocationPdfRequired = "This field is required.";
      isValid = false;
    }
    if (stepData.batchAllocationPdfRequired === "Yes") {
      if (!stepData.pdfFieldSubject || stepData.pdfFieldSubject.trim() === "") {
        newErrors.pdfFieldSubject = "This field is required.";
        isValid = false;
      }
      if (!stepData.pdfFieldObjective || stepData.pdfFieldObjective.trim() === "") {
        newErrors.pdfFieldObjective = "This field is required.";
        isValid = false;
      }
    }
    if (!stepData.sourceProductDoMEqualsMaterial) {
      newErrors.sourceProductDoMEqualsMaterial = "This field is required.";
      isValid = false;
    }

    if (!stepData.cmoUsePOInterface) {
      newErrors.cmoUsePOInterface = "This field is required.";
      isValid = false;
    }
    if (
      !stepData.acceptanceLimitEarlyDelivery ||
      String(stepData.acceptanceLimitEarlyDelivery).trim() === ""
    ) {
      newErrors.acceptanceLimitEarlyDelivery = "This field is required.";
      isValid = false;
    } else if (
      !/^[0-9]+$/.test(String(stepData.acceptanceLimitEarlyDelivery))
    ) {
      newErrors.acceptanceLimitEarlyDelivery = "Please enter a valid number.";
      isValid = false;
    }

    if (
      !stepData.acceptanceLimitLaterDelivery ||
      String(stepData.acceptanceLimitLaterDelivery).trim() === ""
    ) {
      newErrors.acceptanceLimitLaterDelivery = "This field is required.";
      isValid = false;
    } else if (
      !/^[0-9]+$/.test(String(stepData.acceptanceLimitLaterDelivery))
    ) {
      newErrors.acceptanceLimitLaterDelivery = "Please enter a valid number.";
      isValid = false;
    }

    if (
      !stepData.acceptanceLimitLessQuantity ||
      String(stepData.acceptanceLimitLessQuantity).trim() === ""
    ) {
      newErrors.acceptanceLimitLessQuantity = "This field is required.";
      isValid = false;
    } else if (
      stepData.acceptanceLimitLessQuantity !== "N/A" &&
      !/^[0-9]+$/.test(String(stepData.acceptanceLimitLessQuantity))
    ) {
      newErrors.acceptanceLimitLessQuantity =
        "Please enter a valid number or N/A.";
      isValid = false;
    }
    if (
      !stepData.acceptanceLimitMoreQuantity ||
      String(stepData.acceptanceLimitMoreQuantity).trim() === ""
    ) {
      newErrors.acceptanceLimitMoreQuantity = "This field is required.";
      isValid = false;
    } else if (
      stepData.acceptanceLimitMoreQuantity !== "N/A" &&
      !/^[0-9]+$/.test(String(stepData.acceptanceLimitMoreQuantity))
    ) {
      newErrors.acceptanceLimitMoreQuantity =
        "Please enter a valid number or N/A.";
      isValid = false;
    }
    
    // Validation for siteNameFromReport
    if (
      !stepData.siteNameFromReport ||
      stepData.siteNameFromReport.trim() === ""
    ) {
      newErrors.siteNameFromReport = "This field is required.";
      isValid = false;
    }

    // Validate Batch Execution Acceptance Limits — per table
    const activatedTypes = productTypesData.filter((type) => !!type.activated);
    const tableChecks = [
      {
        key: "earlyStatTable",
        limitField: "earlyDateVarianceLimit",
        limitLabel: "Variance Limit (days)",
        updateInERPField: "earlyPODateUpdateInERP",
        updateTypeField: "earlyDateUpdateType",
        updateTypeLabel: "Update Type",
        booleanFields: [
          { field: "earlyPODateUpdateInERP", label: "Update PO Stat and Delivery Date in ERP" },
          { field: "earlyDateWarningMessageRequired", label: "Warning Message" },
        ],
      },
      {
        key: "laterStatTable",
        limitField: "laterDateVarianceLimit",
        limitLabel: "Variance Limit (days)",
        updateInERPField: "laterPODateUpdateInERP",
        updateTypeField: "laterDateUpdateType",
        updateTypeLabel: "Update Type",
        booleanFields: [
          { field: "laterPODateUpdateInERP", label: "Update PO Stat and Delivery Date in ERP" },
          { field: "laterDateWarningMessageRequired", label: "Warning Message" },
        ],
      },
      {
        key: "consumedBatchTable",
        limitField: "consumedQtyVarianceLimitPercentage",
        limitLabel: "Qty Variance Limit (±%)",
        updateInERPField: null,
        updateTypeField: null,
        updateTypeLabel: null,
        booleanFields: [
          { field: "consumedQtyVarianceApprovalRequired", label: "Approval Required" },
          { field: "consumedQtyVarianceWarningMessageRequired", label: "Warning Message" },
          { field: "lotMismatchApprovalRequired", label: "Batch Mismatch - Approval Required" },
          { field: "lotMismatchWarningMessageRequired", label: "Batch Mismatch - Warning Message" },
        ],
      },
      {
        key: "lessProducedTable",
        limitField: "lessProducedQtyVarianceLimitPercentage",
        limitLabel: "Variance Limit (%)",
        updateInERPField: "lessProducedQtyUpdateInERP",
        updateTypeField: "lessProducedQtyUpdateType",
        updateTypeLabel: "Update Type",
        booleanFields: [
          { field: "lessProducedQtyUpdateInERP", label: "Update PO Qty in ERP" },
          { field: "lessProducedQtyWarningMessageRequired", label: "Warning Message" },
        ],
      },
      {
        key: "moreProducedTable",
        limitField: "moreProducedQtyVarianceLimitPercentage",
        limitLabel: "Variance Limit (%)",
        updateInERPField: "moreProducedQtyUpdateInERP",
        updateTypeField: "moreProducedQtyUpdateType",
        updateTypeLabel: "Update Type",
        booleanFields: [
          { field: "moreProducedQtyUpdateInERP", label: "Update PO Qty in ERP" },
          { field: "moreProducedQtyWarningMessageRequired", label: "Warning Message" },
        ],
      },
    ];
    const productTypeTableErrors = {};
    for (const check of tableChecks) {
      const missingFields = [];
      const hasInvalidLimit = activatedTypes.some((t) => { const v = t[check.limitField]; return v === undefined || v === null || String(v).trim() === "" || isNaN(parseInt(v)); });
      if (hasInvalidLimit) missingFields.push(check.limitLabel);
      if (check.updateInERPField) {
        const hasInvalidType = activatedTypes.some((t) => t[check.updateInERPField] && !t[check.updateTypeField]);
        if (hasInvalidType) missingFields.push(check.updateTypeLabel);
      }
      for (const bf of (check.booleanFields || [])) {
        const hasInvalidBool = activatedTypes.some((t) => t[bf.field] === null || t[bf.field] === undefined);
        if (hasInvalidBool) missingFields.push(bf.label);
      }
      if (missingFields.length) {
        productTypeTableErrors[check.key] = `${missingFields.join(", ")} are mandatory fields`;
        isValid = false;
      }
    }
    if (Object.keys(productTypeTableErrors).length > 0) {
      newErrors.productTypeTableErrors = productTypeTableErrors;
    }

    setErrors(newErrors);
    return isValid;
  };

  const handleNextClick = async () => {
    setSubmitted(true);
    if (!validate()) return;

    setLoading(true);
    setError("");

    try {
      const payload = {
        vendorMosymphonyID: cmoDetailsResponse?.organizationId,
        brandOwnerMosymphonyID: brandOwnerMosymphonyID,
        // updatePlantShipmentConfigsFlag: true,
        updateBatchConfiguration: true,
        updateCMODocumentType: true,
        updateDocumentFetchDetails: true,
        updatePOConfigFlag: true,
        updateVendorProductTypeConfig: true,
          updateCMOLevelConfigs: true,
        // BCM-881: the CMO Inventory Mapping travels with this step. The rows
        // are already in the API's own shape, so they go as they stand.
        updateInventoryMapping: true,
        inventoryMapping: stepData.inventoryMapping || [],

        vendorPlantDetails: {
          shipmentDuration: stepData.shipmentDuration,
          cmoBatchShipmentSettingID:
            batchOptionToId[stepData.allowMultipleBatches],
          automateGRP: stepData.automateGoodsReceiptProcess === "Yes",
          allocationOwnedBySponsor:
            typeof stepData.allocationOwnedBySponsor === "boolean"
              ? stepData.allocationOwnedBySponsor
              : stepData.allocationOwnedBySponsor === "Yes",
          batchAllocationPDFNotificationReqd: stepData.batchAllocationPdfRequired === "Yes",
          // batchAllocationPDFNotificationTo: stepData.batchAllocationPdfRequired === "Yes" ? stepData.pdfFieldTo : null,
          // batchAllocationPDFNotificationCC: stepData.batchAllocationPdfRequired === "Yes" ? stepData.pdfFieldCC : null,
          batchAllocationPDFNotificationSubject: stepData.batchAllocationPdfRequired === "Yes" ? stepData.pdfFieldSubject : null,
          batchAllocationPDFNotificationObjective: stepData.batchAllocationPdfRequired === "Yes" ? stepData.pdfFieldObjective : null,
          domPresentOnDigitizationUI:
            stepData.sourceProductDoMEqualsMaterial === "Post Manufacturing Documents"
              ? true
              : stepData.sourceProductDoMEqualsMaterial === "Inventory"
              ? false
              : null,
          
          // CMO Level Configurations (internal UI shape → API shape)
          mosymphonyDisplayOptions: mapMosymphonyDisplayOptionsToApi(stepData.mosymphonyDisplayOptions),
          isIDOCRequired: stepData.isIDOCRequired === "Yes",
          cmoDocumentTypesList: documentTypesData.map((doc) => ({
            documentTypeID: doc.documentTypeID,
            documentTypeName:
              doc.documentTypeName?.trim() || doc.documentTypeName,
            activated: doc.activated,
            newDocumentTypeName:
              doc.newDocumentTypeName === "NA"
                ? null
                : doc.newDocumentTypeName?.trim() || doc.newDocumentTypeName,
            documentType: doc.documentType,
            documentCategoryID: doc.documentCategoryID,
            mandatoryInProcessWorkflow: doc.mandatoryInProcessWorkflow || false,
          })),

          vendorProductTypeConfigs: productTypesData.map((prod) => ({
            productTypeID: prod.productTypeID,
            // productTypeName: prod.productTypeName,
            activated: prod.activated,
            // BCM-891: batch allocation PDF configurations. Defaulted so a CMO
            // created without touching the table still saves definite values.
            documentIDReqd:
              typeof prod.documentIDReqd === "boolean" ? prod.documentIDReqd : false,
            artworkRequired:
              typeof prod.artworkRequired === "boolean" ? prod.artworkRequired : false,
            allocationApprovalReqd:
              typeof prod.allocationApprovalReqd === "boolean"
                ? prod.allocationApprovalReqd
                : false,
            // Derived, never entered — kept in step with artworkRequired so the
            // stored title cannot drift from what the screen shows.
            allocationPDFTitle:
              prod.artworkRequired === true
                ? "Allocation and Artwork Memo"
                : "Allocation Memo",
            consumptionDataReqdForIBDGRN:
              typeof prod.consumptionDataReqdForIBDGRN === "boolean"
                ? prod.consumptionDataReqdForIBDGRN
                : false,
            uploadConsumptionData:
              typeof prod.uploadConsumptionData === "boolean"
                ? prod.uploadConsumptionData
                : false,
            consumptionSameAsAllocation:
              typeof prod.consumptionSameAsAllocation === "boolean"
                ? prod.consumptionSameAsAllocation
                : false,
            manuallyAddConsumptionData:
              typeof prod.manuallyAddConsumptionData === "boolean"
                ? prod.manuallyAddConsumptionData
                : false,
            consumedQtyInfoPresent:
              prod.consumedQtyInfoPresent === true || prod.consumedQtyInfoPresent === false
                ? prod.consumedQtyInfoPresent
                : null,
            consumedQtyMappedTo:
              ["onHandQty", "bomQty"].includes(prod.consumedQtyMappedTo)
                ? prod.consumedQtyMappedTo
                : null,
            expiryDateProvided:
              typeof prod.expiryDateProvided === "boolean"
                ? prod.expiryDateProvided
                : true,
            earlyDateVarianceLimit: parseInt(prod.earlyDateVarianceLimit),
            earlyPODateUpdateInERP: prod.earlyPODateUpdateInERP,
            earlyDateUpdateType: prod.earlyDateUpdateType || null,
            earlyDateWarningMessageRequired: prod.earlyDateWarningMessageRequired,
            laterDateVarianceLimit: parseInt(prod.laterDateVarianceLimit),
            laterPODateUpdateInERP: prod.laterPODateUpdateInERP,
            laterDateUpdateType: prod.laterDateUpdateType || null,
            laterDateWarningMessageRequired: prod.laterDateWarningMessageRequired,
            consumedQtyVarianceLimitPercentage: parseInt(prod.consumedQtyVarianceLimitPercentage),
            consumedQtyVarianceApprovalRequired: prod.consumedQtyVarianceApprovalRequired,
            consumedQtyVarianceWarningMessageRequired: prod.consumedQtyVarianceWarningMessageRequired,
            lotMismatchApprovalRequired: prod.lotMismatchApprovalRequired,
            lotMismatchWarningMessageRequired: prod.lotMismatchWarningMessageRequired,
            lessProducedQtyVarianceLimitPercentage: parseInt(prod.lessProducedQtyVarianceLimitPercentage),
            lessProducedQtyUpdateInERP: prod.lessProducedQtyUpdateInERP,
            lessProducedQtyUpdateType: prod.lessProducedQtyUpdateType || null,
            lessProducedQtyWarningMessageRequired: prod.lessProducedQtyWarningMessageRequired,
            moreProducedQtyVarianceLimitPercentage: parseInt(prod.moreProducedQtyVarianceLimitPercentage),
            moreProducedQtyUpdateInERP: prod.moreProducedQtyUpdateInERP,
            moreProducedQtyUpdateType: prod.moreProducedQtyUpdateType || null,
            moreProducedQtyWarningMessageRequired: prod.moreProducedQtyWarningMessageRequired,
          })),
          siteNameFromReport: stepData.siteNameFromReport,
          cmoToUsePOInterface:
            stepData.cmoUsePOInterface === "Yes"
              ? true
              : stepData.cmoUsePOInterface === "No"
              ? false
              : null,
          acceptanceLimitForEarlyDeliveryDateChangeByCMO:
            stepData.acceptanceLimitEarlyDelivery === "N/A" ||
            stepData.acceptanceLimitEarlyDelivery === "" ||
            !stepData.acceptanceLimitEarlyDelivery
              ? null
              : parseInt(stepData.acceptanceLimitEarlyDelivery),
          acceptanceLimitForLaterDeliveryDateChangeByCMO:
            stepData.acceptanceLimitLaterDelivery === "N/A" ||
            stepData.acceptanceLimitLaterDelivery === "" ||
            !stepData.acceptanceLimitLaterDelivery
              ? null
              : parseInt(stepData.acceptanceLimitLaterDelivery),
          acceptanceLimitForLessDeliveryQuantityChangeByCMO:
            stepData.acceptanceLimitLessQuantity === "N/A"
              ? null
              : parseInt(stepData.acceptanceLimitLessQuantity),
          acceptanceLimitForMoreDeliveryQuantityChangeByCMO:
            stepData.acceptanceLimitMoreQuantity === "N/A"
              ? null
              : parseInt(stepData.acceptanceLimitMoreQuantity),
        },
        ingestionConfigurations: ingestionSections.map((section) => ({
          ingestionConfigId: section.ingestionConfigId || null,
          category: section.category,
          ingestThrough: section.ingestThrough,
          fileHasMultipleTabs: section.fileHasMultipleTabs === "Yes",
          markForDelete: section.markForDelete || false,
          columnMappings: section.tabs.flatMap((tab) => 
            tab.columns.map((col) => ({
              tabName: tab.tabName || "",
              columnName: col.columnName,
              dataElement: col.dataElement,
              dataElementId: col.dataElementId || null,
              fieldType: col.fieldType,
              ingestion: col.ingestion,
              ingestionConfigColumnId: col.ingestionConfigColumnId || null,
              markForDelete: col.markForDelete || false,
            }))
          ),
        })),
        updateIngestionConfigurationFlag: true,
      };
    //  console.log("Payload for API:", payload);
    //  return

      const updateShipmentRes = await axios.post(
        `${API_BASE_URL}/updateVendorPlantDetails`,
        payload
      );

      if (updateShipmentRes?.data?.status) {
        // Call viewCMODetails to get updated ingestionConfigId values
        const viewCMODetailsRes = await axios.post(
          `${API_BASE_URL}/viewCMODetails`,
          {
            cmoOrgId: cmoDetailsResponse?.organizationId,
            ecosystemId: authDetails?.ecosystem_id,
          }
        );

        // Deleted sections are removed on the backend now, so drop them from state
        let updatedIngestionSections = ingestionSections.filter((section) => !section.markForDelete);

        // Map ingestionConfigId from API response back to our state
        if (viewCMODetailsRes?.data?.status && viewCMODetailsRes?.data?.data?.vendorPlantDetails?.vendorPlantDetails?.ingestionConfigurations) {
          const apiIngestionConfigs = viewCMODetailsRes.data.data.vendorPlantDetails.vendorPlantDetails.ingestionConfigurations;
          
          // Configs already claimed by a UI section, so sections sharing category + ingestThrough map one-to-one
          const claimedConfigIds = new Set(
            updatedIngestionSections.map((s) => s.ingestionConfigId).filter(Boolean)
          );

          updatedIngestionSections = updatedIngestionSections.map((section, index) => {
            // Saved sections keep their own config; new ones match an unclaimed config by category and ingestThrough
            const matchingConfig = section.ingestionConfigId
              ? apiIngestionConfigs.find((apiConfig) => apiConfig.ingestionConfigId === section.ingestionConfigId)
              : apiIngestionConfigs.find(
                  (apiConfig) =>
                    !claimedConfigIds.has(apiConfig.ingestionConfigId) &&
                    apiConfig.category === section.category &&
                    apiConfig.ingestThrough === section.ingestThrough
                );
            if (matchingConfig) claimedConfigIds.add(matchingConfig.ingestionConfigId);

            if (matchingConfig && matchingConfig.ingestionConfigId) {
              // Columns already claimed by a UI column, so duplicate rows map one-to-one
              const claimedColumnIds = new Set(
                section.tabs.flatMap((tab) =>
                  tab.columns.map((col) => col.ingestionConfigColumnId).filter(Boolean)
                )
              );
              const tabs = section.tabs.map((tab) => {
                const apiTab = (matchingConfig.tabs || []).find(
                  (t) => (t.tabName || "") === (tab.tabName || "")
                );
                return {
                  ...tab,
                  // Deleted columns are removed on the backend, so drop them from state
                  columns: tab.columns
                    .filter((col) => !col.markForDelete)
                    .map((col) => {
                      if (col.ingestionConfigColumnId) return col;
                      // viewCMODetails returns dataElement as the label, not the key
                      const apiCol = (apiTab?.columns || []).find(
                        (c) =>
                          !claimedColumnIds.has(c.ingestionConfigColumnId) &&
                          c.columnName === col.columnName &&
                          c.fieldType === col.fieldType &&
                          c.ingestion === col.ingestion &&
                          c.dataElement === (col.dataElementLabel || col.dataElement)
                      );
                      if (!apiCol) return col;
                      claimedColumnIds.add(apiCol.ingestionConfigColumnId);
                      return { ...col, ingestionConfigColumnId: apiCol.ingestionConfigColumnId };
                    }),
                };
              });
              return {
                ...section,
                ingestionConfigId: matchingConfig.ingestionConfigId,
                tabs,
              };
            }
            return section;
          });
          
        }

        // Update the state with the new ingestionConfigId values
        setIngestionSections(updatedIngestionSections);

        updateStepData({
          ...stepData,
          domPresentOnDigitizationUI:
            stepData.sourceProductDoMEqualsMaterial === "Post Manufacturing Documents"
              ? true
              : stepData.sourceProductDoMEqualsMaterial === "Inventory"
              ? false
              : null,
          vendorProductTypeConfigs: productTypesData,
          cmoDocumentTypesList: documentTypesData.map((doc) => ({
            documentTypeID: doc.documentTypeID,
            documentTypeName:
              doc.documentTypeName?.trim() || doc.documentTypeName,
            activated: doc.activated,
            newDocumentTypeName:
              doc.newDocumentTypeName === "NA"
                ? null
                : doc.newDocumentTypeName?.trim() || doc.newDocumentTypeName,
            documentType: doc.documentType,
            documentCategoryID: doc.documentCategoryID,
            mandatoryInProcessWorkflow: doc.mandatoryInProcessWorkflow || false,
          })),
          mosymphonyDisplayOptions: mapMosymphonyDisplayOptionsToApi(stepData.mosymphonyDisplayOptions),
          ingestionSections: updatedIngestionSections,
        });
        handleNext();
      } else {
        throw new Error("Failed to update shipment details.");
      }
    } catch (err) {
      setError("Failed to update shipment configurations. Please try again.");
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="cmo-stepper-wrapper">
      <div className="stepper-container">
        <form>
           
          {/* CMO Level Configurations Section */}
          <Typography variant="h6" className={classes.formTitle}>
            CMO Level Configurations
          </Typography>
          <div style={{ marginTop: 20, marginBottom: 40 }}>
            <TableContainer component={Paper} style={{ maxWidth: 1200 }}>
              <Table>
                <TableHead className={classes.tableHead}>
                  <TableRow>
                    <TableCell className={classes.tableCell} style={{ minWidth: 220 }}>
                      <strong>Mosymphony Display Options</strong>
                    </TableCell>
                    <TableCell className={classes.tableCell} align="center">
                      <strong>Purchase Orders Data At</strong>
                    </TableCell>
                    <TableCell className={classes.tableCell} align="center">
                      <strong>Batches Data At</strong>
                    </TableCell>
                    <TableCell className={classes.tableCell} align="center">
                      <strong>Inactive POs Data At</strong>
                    </TableCell>
                    <TableCell className={classes.tableCell} align="center">
                      <strong>Inventory Data At</strong>
                    </TableCell>
                    <TableCell className={classes.tableCell} align="center">
                      <strong>Forecast Data At</strong>
                    </TableCell>
                  </TableRow>
                </TableHead>
                <TableBody>
                  <TableRow>
                    <TableCell>Vendor Level (Vendor ID)</TableCell>
                    <TableCell align="center">
                      <Radio
                        color="primary"
                        name="purchaseOrders"
                        checked={stepData.mosymphonyDisplayOptions?.purchaseOrders === "vendorLevel"}
                        onChange={() => handleMosymphonyDisplayChange("purchaseOrders", "vendorLevel")}
                        disabled={readOnly}
                        classes={{
                          checked: classes.radioChecked,
                          disabled: classes.disabled,
                        }}
                      />
                    </TableCell>
                    <TableCell align="center">
                      <Radio
                        color="primary"
                        name="batches"
                        checked={stepData.mosymphonyDisplayOptions?.batches === "vendorLevel"}
                        onChange={() => handleMosymphonyDisplayChange("batches", "vendorLevel")}
                        disabled={readOnly}
                        classes={{
                          checked: classes.radioChecked,
                          disabled: classes.disabled,
                        }}
                      />
                    </TableCell>
                    <TableCell align="center">
                      <Radio
                        color="primary"
                        name="inactivePOs"
                        checked={stepData.mosymphonyDisplayOptions?.inactivePOs === "vendorLevel"}
                        onChange={() => handleMosymphonyDisplayChange("inactivePOs", "vendorLevel")}
                        disabled={readOnly}
                        classes={{
                          checked: classes.radioChecked,
                          disabled: classes.disabled,
                        }}
                      />
                    </TableCell>
                    <TableCell align="center">
                      <Radio
                        color="primary"
                        name="inventory"
                        checked={stepData.mosymphonyDisplayOptions?.inventory === "vendorLevel"}
                        onChange={() => handleMosymphonyDisplayChange("inventory", "vendorLevel")}
                        disabled={readOnly}
                        classes={{
                          checked: classes.radioChecked,
                          disabled: classes.disabled,
                        }}
                      />
                    </TableCell>
                    <TableCell align="center">
                      <Radio
                        color="primary"
                        name="forecast"
                        checked={stepData.mosymphonyDisplayOptions?.forecast === "vendorLevel"}
                        onChange={() => handleMosymphonyDisplayChange("forecast", "vendorLevel")}
                        disabled={true}
                        classes={{
                          checked: classes.radioCheckedForecast,
                          disabled: classes.disabled,
                        }}
                      />
                    </TableCell>
                  </TableRow>
                  <TableRow>
                    <TableCell>Manufacturing Plant Level (Manufacturing Plant ID)</TableCell>
                    <TableCell align="center">
                      <Radio
                        color="primary"
                        name="purchaseOrders"
                        checked={stepData.mosymphonyDisplayOptions?.purchaseOrders === "plantLevel"}
                        onChange={() => handleMosymphonyDisplayChange("purchaseOrders", "plantLevel")}
                        disabled={readOnly || isPlantLevelDisabled}
                        classes={{
                          checked: classes.radioChecked,
                          disabled: classes.disabled,
                        }}
                      />
                    </TableCell>
                    <TableCell align="center">
                      <Radio
                        color="primary"
                        name="batches"
                        checked={stepData.mosymphonyDisplayOptions?.batches === "plantLevel"}
                        onChange={() => handleMosymphonyDisplayChange("batches", "plantLevel")}
                        disabled={readOnly || isPlantLevelDisabled}
                        classes={{
                          checked: classes.radioChecked,
                          disabled: classes.disabled,
                        }}
                      />
                    </TableCell>
                    <TableCell align="center">
                      <Radio
                        color="primary"
                        name="inactivePOs"
                        checked={stepData.mosymphonyDisplayOptions?.inactivePOs === "plantLevel"}
                        onChange={() => handleMosymphonyDisplayChange("inactivePOs", "plantLevel")}
                        disabled={readOnly || isPlantLevelDisabled}
                        classes={{
                          checked: classes.radioChecked,
                          disabled: classes.disabled,
                        }}
                      />
                    </TableCell>
                    <TableCell align="center">
                      <Radio
                        color="primary"
                        name="inventory"
                        checked={stepData.mosymphonyDisplayOptions?.inventory === "plantLevel"}
                        onChange={() => handleMosymphonyDisplayChange("inventory", "plantLevel")}
                        disabled={readOnly || isPlantLevelDisabled}
                        classes={{
                          checked: classes.radioChecked,
                          disabled: classes.disabled,
                        }}
                      />
                    </TableCell>
                    <TableCell align="center">
                      <Radio
                        color="primary"
                        name="forecast"
                        checked={stepData.mosymphonyDisplayOptions?.forecast === "plantLevel"}
                        onChange={() => handleMosymphonyDisplayChange("forecast", "plantLevel")}
                        disabled={true}
                        classes={{
                          checked: classes.radioCheckedForecast,
                          disabled: classes.disabled,
                        }}
                      />
                    </TableCell>
                  </TableRow>
                </TableBody>
              </Table>
            </TableContainer>

          </div>

          {/*
            BCM-881 — the CMO Inventory Mapping, which sets this CMO's own
            inventory statuses and columns, the names they are displayed
            under, and the quantities they contribute to. It is held against
            the CMO in the same step as the display options above, and the
            rows travel in stepData so they are saved with the rest of it.
          */}
          <CmoInventoryMapping
            value={stepData.inventoryMapping || []}
            onChange={(rows) =>
              setStepData((prev) => ({ ...prev, inventoryMapping: rows }))
            }
            readOnly={readOnly}
            sponsorId={brandOwnerMosymphonyID}
          />

          <Grid className="two-col-forms-grid" container spacing={3} style={{ marginTop: 24 }}>
            <Grid item xs={12} sm={6}>
              <FormControl className={classes.formField}>
                <Typography component="label" htmlFor="isIDOCRequired">
                  ERP-to-ERP Connectivity{!readOnly && <span style={{ color: "red" }}> *</span>}
                </Typography>
                {readOnly ? (
                  <Typography>{stepData?.isIDOCRequired || "N/A"}</Typography>
                ) : (
                  <Select
                    id="isIDOCRequired"
                    name="isIDOCRequired"
                    value={stepData.isIDOCRequired || ""}
                    onChange={handleFieldChange}
                    variant="outlined"
                    fullWidth
                    displayEmpty
                  >
                    <MenuItem value="" disabled>Select from the list</MenuItem>
                    <MenuItem value="Yes">Yes</MenuItem>
                    <MenuItem value="No">No</MenuItem>
                  </Select>
                )}
              </FormControl>
            </Grid>
          </Grid>

          {
            <Divider
              style={{
                margin: "40px 0px 0px 0px",
                backgroundColor: "#707070",
                height: 1,
                zIndex: 4,
              }}
            />
          }
          {/* BCM-891: Product Types moved above Batch Configurations, per spec. */}
          <Typography variant="h6" className={classes.formTitle}>
            Product Types
          </Typography>
          <div className={classes.tabContentContainer}>
            <ProductTypes
              isProdLoading={isProdLoading}
              productTypesData={productTypesData}
              readOnly={readOnly}
              setproductTypesData={setproductTypesData}
              productTypeTableErrors={errors.productTypeTableErrors || {}}
            />
          </div>
          <Typography variant="h6" className={classes.formTitle}>
            Batch Configurations
          </Typography>
          <Grid className="two-col-forms-grid" container spacing={3}>
            <Grid item xs={12} sm={6}>
              <FormControl className={classes.formField}>
                <Typography component="label" htmlFor="allowMultipleBatches">
                  Allow multiple batches to be shipped in single delivery{" "}
                  {!readOnly && <span style={{ color: "red" }}>*</span>}
                </Typography>
                {readOnly ? (
                  <Typography>
                    {stepData?.allowMultipleBatches ||
                      formData?.allowMultipleBatches ||
                      (formData?.cmoBatchShipmentSettingID !== undefined && formData?.cmoBatchShipmentSettingID !== null
                        ? batchOptions[formData.cmoBatchShipmentSettingID - 1]
                        : null) ||
                      (stepData?.cmoBatchShipmentSettingID !== undefined && stepData?.cmoBatchShipmentSettingID !== null
                        ? batchOptions[stepData.cmoBatchShipmentSettingID - 1]
                        : null) ||
                      "N/A"}
                  </Typography>
                ) : (
                  <>
                    <Select
                      id="allowMultipleBatches"
                      name="allowMultipleBatches"
                      value={stepData.allowMultipleBatches || ""}
                      onChange={handleFieldChange}
                      variant="outlined"
                      fullWidth
                      required
                      sx={inputFieldStyles}
                      inputProps={commonInlineStyles.inputProps}
                      style={commonInlineStyles.input}
                      error={submitted && Boolean(errors.allowMultipleBatches)}
                      displayEmpty
                    >
                      <MenuItem value="" disabled>
                        Select from the list
                      </MenuItem>
                    {batchOptions.map((opt) => (
                      <MenuItem key={opt} value={opt}>
                        {opt}
                      </MenuItem>
                    ))}
                  </Select>
                    {submitted && errors.allowMultipleBatches && (
                      <FormHelperText error>
                        {errors.allowMultipleBatches}
                      </FormHelperText>
                    )}
                  </>
                )}
              </FormControl>
            </Grid>
            <Grid item xs={12} sm={6}>
              <FormControl className={classes.formField}>
                <Typography component="label" htmlFor="shipmentDuration">
                  CMO Shipment Duration (Days){" "}
                  {!readOnly && <span style={{ color: "red" }}>*</span>}
                </Typography>
                {readOnly ? (
                  <Typography>{formData?.shipmentDuration || "N/A"}</Typography>
                ) : (
                  <TextField
                    id="shipmentDuration"
                    name="shipmentDuration"
                    value={stepData.shipmentDuration || ""}
                    onChange={handleFieldChange}
                    variant="outlined"
                    placeholder="Enter Number of days"
                    fullWidth
                    required
                    InputProps={{ style: commonInlineStyles.input }}
                    sx={inputFieldStyles}
                    inputProps={{ ...commonInlineStyles.inputProps }}
                    style={commonInlineStyles.input}
                    error={submitted && Boolean(errors.shipmentDuration)}
                    helperText={
                      submitted && errors.shipmentDuration
                        ? errors.shipmentDuration
                        : ""
                    }
                    onInput={(e) => {
                      e.target.value = e.target.value.replace(/[^0-9]/g, "");
                    }}
                  />
                )}
              </FormControl>
            </Grid>
            <Grid item xs={12} sm={6}>
              <FormControl className={classes.formField}>
                <Typography
                  component="label"
                  htmlFor="automateGoodsReceiptProcess"
                >
                  Automate goods receipt process{" "}
                  {!readOnly && <span style={{ color: "red" }}>*</span>}
                </Typography>
                {readOnly ? (
                  <Typography>
                    {formData?.automateGoodsReceiptProcess || "N/A"}
                  </Typography>
                ) : (
                  <>
                    <Select
                      id="automateGoodsReceiptProcess"
                      name="automateGoodsReceiptProcess"
                      value={stepData.automateGoodsReceiptProcess || ""}
                      onChange={handleFieldChange}
                      variant="outlined"
                      fullWidth
                      required
                      sx={inputFieldStyles}
                      inputProps={commonInlineStyles.inputProps}
                      style={commonInlineStyles.input}
                      error={
                        submitted && Boolean(errors.automateGoodsReceiptProcess)
                      }
                      displayEmpty
                    >
                      <MenuItem value="" disabled>
                        Select from the list
                      </MenuItem>
                      <MenuItem value="Yes">Yes</MenuItem>
                      <MenuItem value="No">No</MenuItem>
                    </Select>
                    {submitted && errors.automateGoodsReceiptProcess && (
                      <FormHelperText error>
                        {errors.automateGoodsReceiptProcess}
                      </FormHelperText>
                    )}
                  </>
                )}
              </FormControl>
            </Grid>
             <Grid item xs={12} sm={6}>
              <FormControl className={classes.formField}>
                <Typography
                  component="label"
                  htmlFor="allocationOwnedBySponsor"
                >
                  Allocation owned by Sponsor{" "}
                  {!readOnly && <span style={{ color: "red" }}>*</span>}
                </Typography>
                {readOnly ? (
                  <Typography>
                    {typeof formData?.allocationOwnedBySponsor === "boolean"
                      ? formData?.allocationOwnedBySponsor
                        ? "Yes"
                        : "No"
                      : formData?.allocationOwnedBySponsor || "N/A"}
                  </Typography>
                ) : (
                  <>
                    <Select
                      id="allocationOwnedBySponsor"
                      name="allocationOwnedBySponsor"
                      value={
                        typeof stepData.allocationOwnedBySponsor === "boolean"
                          ? stepData.allocationOwnedBySponsor
                            ? "Yes"
                            : "No"
                          : stepData.allocationOwnedBySponsor || ""
                      }
                      onChange={handleFieldChange}
                      variant="outlined"
                      fullWidth
                      required
                      sx={inputFieldStyles}
                      inputProps={commonInlineStyles.inputProps}
                      style={commonInlineStyles.input}
                      error={
                        submitted && Boolean(errors.allocationOwnedBySponsor)
                      }
                      displayEmpty
                    >
                      <MenuItem value="" disabled>
                        Select from the list
                      </MenuItem>
                      <MenuItem value="Yes">Yes</MenuItem>
                      <MenuItem value="No">No</MenuItem>
                    </Select>
                    {submitted && errors.allocationOwnedBySponsor && (
                      <FormHelperText error>
                        {errors.allocationOwnedBySponsor}
                      </FormHelperText>
                    )}
                  </>
                )}
              </FormControl>
            </Grid>
            
            <Grid item xs={12} sm={6}>
              <FormControl className={classes.formField}>
                <Typography
                  component="label"
                  htmlFor="batchAllocationPdfRequired"
                >
                  Batch Allocation Notification PDF Required{" "}
                  {!readOnly && <span style={{ color: "red" }}>*</span>}
                </Typography>
                {readOnly ? (
                  <Typography>
                    {formData?.batchAllocationPdfRequired || "N/A"}
                  </Typography>
                ) : (
                  <>
                    <Select
                      id="batchAllocationPdfRequired"
                      name="batchAllocationPdfRequired"
                      value={stepData.batchAllocationPdfRequired || ""}
                      onChange={handleFieldChange}
                      variant="outlined"
                      fullWidth
                      required
                      sx={inputFieldStyles}
                      inputProps={commonInlineStyles.inputProps}
                      style={commonInlineStyles.input}
                      error={
                        submitted && Boolean(errors.batchAllocationPdfRequired)
                      }
                      displayEmpty
                    >
                      <MenuItem value="" disabled>
                        Select from the list
                      </MenuItem>
                      <MenuItem value="Yes">Yes</MenuItem>
                      <MenuItem value="No">No</MenuItem>
                    </Select>
                    {submitted && errors.batchAllocationPdfRequired && (
                      <FormHelperText error>
                        {errors.batchAllocationPdfRequired}
                      </FormHelperText>
                    )}
                  </>
                )}
              </FormControl>
            </Grid>
            <Grid item xs={12} sm={6}></Grid>
            <Grid item xs={12} sm={6}>
              <FormControl className={classes.formField}>
                <Typography component="label" htmlFor="sourceProductDoMEqualsMaterial">
                  Source for Product DoM = Material DoM cases{" "}
                  {!readOnly && <span style={{ color: "red" }}>*</span>}
                </Typography>
                {readOnly ? (
                  <Typography>
                    {stepData.sourceProductDoMEqualsMaterial || ""}
                  </Typography>
                ) : (
                  <>
                    <Select
                      id="sourceProductDoMEqualsMaterial"
                      name="sourceProductDoMEqualsMaterial"
                      value={stepData.sourceProductDoMEqualsMaterial || ""}
                      onChange={handleFieldChange}
                      variant="outlined"
                      fullWidth
                      required
                      sx={inputFieldStyles}
                      inputProps={commonInlineStyles.inputProps}
                      style={commonInlineStyles.input}
                      error={submitted && Boolean(errors.sourceProductDoMEqualsMaterial)}
                      displayEmpty
                    >
                      <MenuItem value="" disabled>
                        Select from the list
                      </MenuItem>
                      <MenuItem value="Post Manufacturing Documents">
                        Post Manufacturing Documents
                      </MenuItem>
                      <MenuItem value="Inventory">Inventory</MenuItem>
                    </Select>
                    {submitted && errors.sourceProductDoMEqualsMaterial && (
                      <FormHelperText error>
                        {errors.sourceProductDoMEqualsMaterial}
                      </FormHelperText>
                    )}
                  </>
                )}
              </FormControl>
            </Grid>
            <Grid item xs={12} sm={6}>
              <FormControl className={classes.formField}>
                <Typography component="label">
                  DoM present on Digitalization UI
                </Typography>
                <Typography>
                  {stepData.sourceProductDoMEqualsMaterial === "Post Manufacturing Documents"
                    ? "Yes"
                    : stepData.sourceProductDoMEqualsMaterial === "Inventory"
                    ? "No"
                    : ""}
                </Typography>
              </FormControl>
            </Grid>
            <Grid item xs={12} sm={6}>
              <FormControl className={classes.formField}>
                <Typography component="label">
                  Source for Product DoM ≠ Material DoM cases
                </Typography>
                <Typography>
                  Post Manufacturing Documents
                  {/* {stepData.sourceProductDoMEqualsMaterial === "Post Manufacturing Documents"
                    ? "Inventory"
                    : stepData.sourceProductDoMEqualsMaterial === "Inventory"
                    ? "Post Manufacturing Documents"
                    : "-"} */}
                </Typography>
              </FormControl>
            </Grid>
            <Grid item xs={12} sm={6}>
              <FormControl className={classes.formField}>
                <Typography component="label">
                  DoM present on Digitalization UI
                </Typography>
                <Typography>
                  Yes
                  {/* {stepData.sourceProductDoMEqualsMaterial === "Post Manufacturing Documents"
                    ? "No"
                    : stepData.sourceProductDoMEqualsMaterial === "Inventory"
                    ? "Yes"
                    : "-"} */}
                </Typography>
              </FormControl>
            </Grid>
            <Grid item xs={12} sm={12} style={{ maxWidth: "none" }}>
              <Typography
                style={{
                  // fontSize: 12,
                  // color: "#666",
                  // fontStyle: "italic",
                  // marginTop: 0,
                  // width: 600,
                  maxWidth: "100%",
                  textAlign: "left",
                  marginTop: 2,
                }}
              >
                {`Note - `}
                <br />
                {`Sponsor can allocate batch for a PO, even when 'Allocation owned by Sponsor' configuration value is No.`}
              </Typography>
            </Grid>
          </Grid>
          <Divider
            style={{
              margin: "40px 0px 0px 0px",
              backgroundColor: "#707070",
              height: 1,
              zIndex: 4,
            }}
          />
          {/* BCM-891: section renamed from "Batch Allocation Notification PDF
              Fields". */}
          <Typography variant="h6" className={classes.formTitle}>
            Batch Allocation Notification PDF Configurations
          </Typography>

          {/* BCM-891: Product Type Configurations, above To / CC / Subject /
              Objective as the spec requires. productTypesData is owned by this
              component and passed down to <ProductTypes>, so the same rows are
              edited here and flow into the one vendorProductTypeConfigs payload
              -- no second source of truth. Every product type is listed, as the
              spec requires and as View and Update list them, so a value set
              here cannot appear against a different product type elsewhere. */}

          <ProductTypePdfConfigTable
            rows={productTypesData}
            disabled={readOnly}
            onChange={handlePdfConfigChange}
            headClassName={classes.tableHead}
            headCellClassName={classes.tableCell}
            tableContainerClassName={classes.table}
          />

          <Grid className="two-col-forms-grid" container spacing={3}>
            <Grid item xs={12} sm={6}>
              <FormControl className={classes.formField}>
                <Typography component="label" htmlFor="pdfFieldTo">
                  To {!readOnly && <span style={{ color: "red" }}>*</span>}
                </Typography>
                {readOnly ? (
                  <Typography>{formData?.pdfFieldTo || "N/A"}</Typography>
                ) : (
                  <Select
                    select
                    id="pdfFieldTo"
                    name="pdfFieldTo"
                    value={stepData.pdfFieldTo || ""}
                    onChange={handleFieldChange}
                    variant="outlined"
                    placeholder="Select option"
                    fullWidth
                    required
                    disabled={true}
                    InputProps={{ style: commonInlineStyles.input }}
                    sx={inputFieldStyles}
                    inputProps={commonInlineStyles.inputProps}
                    style={commonInlineStyles.input}
                    error={submitted && Boolean(errors.pdfFieldTo)}
                    helperText={
                      submitted && errors.pdfFieldTo
                        ? errors.pdfFieldTo
                        : ""
                    }
                    displayEmpty
                  >
                    <MenuItem value="" disabled>
                      Select from the list
                    </MenuItem>
                    <MenuItem value="CMO Name">CMO Name</MenuItem>
                  </Select>
                )}
              </FormControl>
            </Grid>
            <Grid item xs={12} sm={6}>
              <FormControl className={classes.formField}>
                <Typography component="label" htmlFor="pdfFieldCC">
                  CC {!readOnly && <span style={{ color: "red" }}>*</span>}
                </Typography>
                {readOnly ? (
                  <Typography>{formData?.pdfFieldCC || "N/A"}</Typography>
                ) : (
                  <Select
                    select
                    id="pdfFieldCC"
                    name="pdfFieldCC"
                    value={stepData.pdfFieldCC || ""}
                    onChange={handleFieldChange}
                    variant="outlined"
                    placeholder="Select option"
                    fullWidth
                    required
                    disabled={true}
                    InputProps={{ style: commonInlineStyles.input }}
                    sx={{
                      ...inputFieldStyles,
                      '& .MuiSelect-select': {
                        whiteSpace: 'normal !important',
                        overflow: 'visible !important',
                        textOverflow: 'clip !important',
                        lineHeight: '1.5',
                        paddingTop: '8px',
                        paddingBottom: '8px',
                      }
                    }}
                    inputProps={commonInlineStyles.inputProps}
                    style={{
                      ...commonInlineStyles.input,
                      height: 'auto',
                      minHeight: '40px',
                    }}
                    error={submitted && Boolean(errors.pdfFieldCC)}
                    helperText={
                      submitted && errors.pdfFieldCC
                        ? errors.pdfFieldCC
                        : ""
                    }
                    displayEmpty
                    renderValue={(selected) => (
                      <div style={{ whiteSpace: 'normal', wordWrap: 'break-word' }}>
                        {selected || "Select from the list"}
                      </div>
                    )}
                    MenuProps={{
                      PaperProps: {
                        style: {
                          maxWidth: 600,
                        },
                      },
                    }}
                  >
                    <MenuItem value="" disabled>
                      Select from the list
                    </MenuItem>
                    <MenuItem 
                      value="All the users associated with the CMO, Brand and Product Type"
                      style={{ whiteSpace: 'normal', wordWrap: 'break-word' }}
                    >
                      All the users associated with the CMO, Brand and Product Type
                    </MenuItem>
                  </Select>
                )}
              </FormControl>
            </Grid>
            <Grid item xs={12} sm={6}>
              <FormControl className={`${classes.formField} ${classes.noPaddingMultiline}`}>
                <Typography component="label" htmlFor="pdfFieldSubject">
                  Subject {!readOnly && <span style={{ color: "red" }}>*</span>}
                </Typography>
                {readOnly ? (
                  <Typography>{formData?.pdfFieldSubject || "N/A"}</Typography>
                ) : (
                  <TextField
                    id="pdfFieldSubject"
                    name="pdfFieldSubject"
                    value={stepData.pdfFieldSubject || ""}
                    onChange={handleFieldChange}
                    variant="outlined"
                    placeholder="Enter subject"
                    fullWidth
                    multiline
                    required
                    disabled={stepData.batchAllocationPdfRequired !== "Yes"}
                    sx={{
                      ...inputFieldStyles,
                      height: '100px !important',
                      '& .MuiOutlinedInput-root': {
                        padding: '0 !important',
                        height: '100px !important',
                        minHeight: '100px !important',
                        maxHeight: '100px !important',
                        alignItems: 'flex-start !important',
                      },
                      '& .MuiInputBase-root': {
                        height: '100px !important',
                        minHeight: '100px !important',
                        maxHeight: '100px !important',
                      },
                      '& textarea': {
                        height: '100px !important',
                        minHeight: '100px !important',
                        maxHeight: '100px !important',
                        overflow: 'auto !important',
                      },
                      '& .MuiOutlinedInput-input': {
                        padding: '8.5px 14px !important',
                        height: '100px !important',
                        minHeight: '100px !important',
                        maxHeight: '100px !important',
                        overflow: 'auto !important',
                        boxSizing: 'border-box !important',
                      }
                    }}
                    inputProps={{ ...commonInlineStyles.inputProps, maxLength: 255, style: { height: '100px', overflow: 'auto' } }}
                    error={submitted && Boolean(errors.pdfFieldSubject)}
                    helperText={
                      submitted && errors.pdfFieldSubject
                        ? errors.pdfFieldSubject
                        : `${stepData.pdfFieldSubject?.length || 0}/255 characters`
                    }
                  />
                )}
              </FormControl>
            </Grid>
            <Grid item xs={12} sm={6}>
              <FormControl className={`${classes.formField} ${classes.noPaddingMultiline}`}>
                <Typography component="label" htmlFor="pdfFieldObjective">
                  Objective {!readOnly && <span style={{ color: "red" }}>*</span>}
                </Typography>
                {readOnly ? (
                  <Typography>{formData?.pdfFieldObjective || "N/A"}</Typography>
                ) : (
                  <TextField
                    id="pdfFieldObjective"
                    name="pdfFieldObjective"
                    value={stepData.pdfFieldObjective || ""}
                    onChange={handleFieldChange}
                    variant="outlined"
                    placeholder="Enter objective"
                    fullWidth
                    multiline
                    required
                    disabled={stepData.batchAllocationPdfRequired !== "Yes"}
                    sx={{
                      ...inputFieldStyles,
                      height: '175px !important',
                      '& .MuiOutlinedInput-root': {
                        padding: '0 !important',
                        height: '175px !important',
                        minHeight: '175px !important',
                        maxHeight: '175px !important',
                        alignItems: 'flex-start !important',
                      },
                      '& .MuiInputBase-root': {
                        height: '175px !important',
                        minHeight: '175px !important',
                        maxHeight: '175px !important',
                      },
                      '& textarea': {
                        height: '175px !important',
                        minHeight: '175px !important',
                        maxHeight: '175px !important',
                        overflow: 'auto !important',
                      },
                      '& .MuiOutlinedInput-input': {
                        padding: '8.5px 14px !important',
                        height: '175px !important',
                        minHeight: '175px !important',
                        maxHeight: '175px !important',
                        overflow: 'auto !important',
                        boxSizing: 'border-box !important',
                      }
                    }}
                    inputProps={{ ...commonInlineStyles.inputProps, maxLength: 500, style: { height: '175px', overflow: 'auto' } }}
                    error={submitted && Boolean(errors.pdfFieldObjective)}
                    helperText={
                      submitted && errors.pdfFieldObjective
                        ? errors.pdfFieldObjective
                        : `${stepData.pdfFieldObjective?.length || 0}/500 characters`
                    }
                  />
                )}
              </FormControl>
            </Grid>
          </Grid>
          {
            <Divider
              style={{
                margin: "80px 0px 0px 0px",
                backgroundColor: "#707070",
                height: 1,
                zIndex: 4,
              }}
            />
          }
          <Typography variant="h6" className={classes.formTitle}>
            PO Configurations
          </Typography>
          <Grid className="two-col-forms-grid" container spacing={3}>
            <Grid item xs={12} sm={6}>
              <FormControl className={classes.formField}>
                <Typography component="label" htmlFor="cmoUsePOInterface">
                  CMO to use PO Interface{" "}
                  {!readOnly && <span style={{ color: "red" }}>*</span>}
                </Typography>
                {readOnly ? (
                  <Typography>
                    {formData?.cmoUsePOInterface || "N/A"}
                  </Typography>
                ) : (
                  <>
                    <Select
                      id="cmoUsePOInterface"
                      name="cmoUsePOInterface"
                      value={stepData.cmoUsePOInterface || ""}
                      onChange={handleFieldChange}
                      variant="outlined"
                      fullWidth
                      required
                      sx={inputFieldStyles}
                      inputProps={commonInlineStyles.inputProps}
                      style={commonInlineStyles.input}
                      error={submitted && Boolean(errors.cmoUsePOInterface)}
                      displayEmpty
                    >
                      <MenuItem value="" disabled>
                        Select from the list
                      </MenuItem>
                      <MenuItem value="Yes">Yes</MenuItem>
                      <MenuItem value="No">No</MenuItem>
                    </Select>
                    {submitted && errors.cmoUsePOInterface && (
                      <FormHelperText error>
                        {errors.cmoUsePOInterface}
                      </FormHelperText>
                    )}
                  </>
                )}
              </FormControl>
            </Grid>
            <Grid item xs={12} sm={6}>
              <FormControl className={classes.formField}>
                <Typography
                  component="label"
                  htmlFor="acceptanceLimitEarlyDelivery"
                >
                  Acceptance limit for (early) delivery date change by CMO (in
                  days) {!readOnly && <span style={{ color: "red" }}>*</span>}
                </Typography>
                {readOnly ? (
                  <Typography>
                    {formData?.acceptanceLimitEarlyDelivery || "N/A"}
                  </Typography>
                ) : (
                  <TextField
                    id="acceptanceLimitEarlyDelivery"
                    name="acceptanceLimitEarlyDelivery"
                    value={stepData.acceptanceLimitEarlyDelivery || ""}
                    onChange={handleFieldChange}
                    variant="outlined"
                    placeholder="Enter number of days"
                    fullWidth
                    required
                    InputProps={{ style: commonInlineStyles.input }}
                    sx={inputFieldStyles}
                    inputProps={{ ...commonInlineStyles.inputProps }}
                    style={commonInlineStyles.input}
                    error={
                      submitted && Boolean(errors.acceptanceLimitEarlyDelivery)
                    }
                    helperText={
                      submitted && errors.acceptanceLimitEarlyDelivery
                        ? errors.acceptanceLimitEarlyDelivery
                        : ""
                    }
                    onInput={(e) => {
                      e.target.value = e.target.value.replace(/[^0-9]/g, "");
                    }}
                  />
                )}
              </FormControl>
            </Grid>
            <Grid item xs={12} sm={6}>
              <FormControl className={classes.formField}>
                <Typography
                  component="label"
                  htmlFor="acceptanceLimitLaterDelivery"
                >
                  Acceptance limit for (later) delivery date change by CMO (in
                  days) {!readOnly && <span style={{ color: "red" }}>*</span>}
                </Typography>
                {readOnly ? (
                  <Typography>
                    {formData?.acceptanceLimitLaterDelivery || "N/A"}
                  </Typography>
                ) : (
                  <TextField
                    id="acceptanceLimitLaterDelivery"
                    name="acceptanceLimitLaterDelivery"
                    value={stepData.acceptanceLimitLaterDelivery || ""}
                    onChange={handleFieldChange}
                    variant="outlined"
                    placeholder="Enter number of days"
                    fullWidth
                    required
                    InputProps={{ style: commonInlineStyles.input }}
                    sx={inputFieldStyles}
                    inputProps={{ ...commonInlineStyles.inputProps }}
                    style={commonInlineStyles.input}
                    error={
                      submitted && Boolean(errors.acceptanceLimitLaterDelivery)
                    }
                    helperText={
                      submitted && errors.acceptanceLimitLaterDelivery
                        ? errors.acceptanceLimitLaterDelivery
                        : ""
                    }
                    onInput={(e) => {
                      e.target.value = e.target.value.replace(/[^0-9]/g, "");
                    }}
                  />
                )}
              </FormControl>
            </Grid>
            <Grid item xs={12} sm={6}>
              <FormControl className={classes.formField}>
                <Typography
                  component="label"
                  htmlFor="acceptanceLimitLessQuantity"
                >
                  Acceptance limit for (less) delivery quantity change by CMO
                  (%)
                  {!readOnly && <span style={{ color: "red" }}> *</span>}
                </Typography>
                {readOnly ? (
                  <Typography>
                    {formData?.acceptanceLimitLessQuantity || "N/A"}
                  </Typography>
                ) : (
                  <TextField
                    id="acceptanceLimitLessQuantity"
                    name="acceptanceLimitLessQuantity"
                    value={stepData.acceptanceLimitLessQuantity || ""}
                    onChange={handleFieldChange}
                    variant="outlined"
                    placeholder="Enter percentage"
                    fullWidth
                    required
                    InputProps={{ style: commonInlineStyles.input }}
                    sx={inputFieldStyles}
                    inputProps={commonInlineStyles.inputProps}
                    style={commonInlineStyles.input}
                    error={
                      submitted && Boolean(errors.acceptanceLimitLessQuantity)
                    }
                    helperText={
                      submitted && errors.acceptanceLimitLessQuantity
                        ? errors.acceptanceLimitLessQuantity
                        : ""
                    }
                  />
                )}
              </FormControl>
            </Grid>
            <Grid item xs={12} sm={6}>
              <FormControl className={classes.formField}>
                <Typography
                  component="label"
                  htmlFor="acceptanceLimitMoreQuantity"
                >
                  Acceptance limit for (more) delivery quantity change by CMO
                  (%)
                  {!readOnly && <span style={{ color: "red" }}> *</span>}
                </Typography>
                {readOnly ? (
                  <Typography>
                    {formData?.acceptanceLimitMoreQuantity || "N/A"}
                  </Typography>
                ) : (
                  <TextField
                    id="acceptanceLimitMoreQuantity"
                    name="acceptanceLimitMoreQuantity"
                    value={stepData.acceptanceLimitMoreQuantity || ""}
                    onChange={handleFieldChange}
                    variant="outlined"
                    placeholder="Enter percentage"
                    fullWidth
                    required
                    InputProps={{ style: commonInlineStyles.input }}
                    sx={inputFieldStyles}
                    inputProps={commonInlineStyles.inputProps}
                    style={commonInlineStyles.input}
                    error={
                      submitted && Boolean(errors.acceptanceLimitMoreQuantity)
                    }
                    helperText={
                      submitted && errors.acceptanceLimitMoreQuantity
                        ? errors.acceptanceLimitMoreQuantity
                        : ""
                    }
                  />
                )}
              </FormControl>
            </Grid>
          </Grid>
          {
            <Divider
              style={{
                margin: "80px 0px 0px 0px",
                backgroundColor: "#707070",
                height: 1,
                zIndex: 4,
              }}
            />
          }
          {
            <Divider
              style={{
                margin: "80px 0px 0px 0px",
                backgroundColor: "#707070",
                height: 1,
                zIndex: 4,
              }}
            />
          }
         
          
          <Typography variant="h6" className={classes.formTitle}>
            Document Types
          </Typography>
          <div className={classes.tabContentContainer}>
            <DocumentTypes
              documentTypesData={documentTypesData}
              isDocLoading={isDocLoading}
              setdocumentTypesData={setdocumentTypesData}
              readOnly={readOnly}
            />
          </div>

          {
            <Divider
              style={{
                margin: "80px 0px 0px 0px",
                backgroundColor: "#707070",
                height: 1,
                zIndex: 4,
              }}
            />
          }
          <Typography variant="h6" className={classes.formTitle}>
            Document Fetch Details
          </Typography>

          {/* CMO Site Value In The CMO Reports Field */}
          <Grid
            container
            spacing={3}
            style={{ marginTop: 0, marginBottom: 24 }}
          >
            <Grid item xs={12} sm={6}>
              <FormControl className={classes.formField}>
                <Typography component="label" htmlFor="siteNameFromReport">
                  CMO site value in the CMO reports{" "}
                  {!readOnly && <span style={{ color: "red" }}>*</span>}
                </Typography>
                {readOnly ? (
                  <Typography>
                    {stepData?.siteNameFromReport ||
                      formData?.siteNameFromReport ||
                      "N/A"}
                  </Typography>
                ) : (
                  <TextField
                    id="siteNameFromReport"
                    name="siteNameFromReport"
                    value={stepData.siteNameFromReport || ""}
                    onChange={handleFieldChange}
                    variant="outlined"
                    placeholder="Enter text here"
                    fullWidth
                    required
                    InputProps={{ style: commonInlineStyles.input }}
                    sx={inputFieldStyles}
                    inputProps={{ ...commonInlineStyles.inputProps }}
                    style={commonInlineStyles.input}
                    error={submitted && Boolean(errors.siteNameFromReport)}
                    helperText={
                      submitted && errors.siteNameFromReport
                        ? errors.siteNameFromReport
                        : ""
                    }
                    onInput={(e) => {
                      e.target.value = e.target.value
                        .replace(/[^a-zA-Z0-9\s&.,\-/]/g, "")
                        .replace(
                          /(\s{2,}|&{2,}|,-{2,}|,{2,}|\.{2,}|\/{2,}|'{2,}|\({2,}|\){2,})/g,
                          (match) => match[0]
                        );
                    }}
                  />
                )}
              </FormControl>
            </Grid>
          </Grid>

          {<Divider
            style={{
              margin: "80px 0px 0px 0px",
              backgroundColor: "#707070",
              height: 1,
              zIndex: 4,
            }}
          />}
          <Typography variant="h6" className={classes.formTitle}>
            Ingestion Configuration
          </Typography>
          <div className={classes.tabContentContainer} style={{ maxWidth: "none" }}>
            <IngestionConfiguration
              ingestionSections={ingestionSections}
              setIngestionSections={setIngestionSections}
              readOnly={readOnly}
              dataElements={dataElements}
              isDataElementsLoading={isDataElementsLoading}
            />
          </div>

          {!readOnly && (
            <div
              className="stepper-navigation-btns"
              style={{
                display: "flex",
                justifyContent: "space-between",
                marginTop: 32,
              }}
            >
              <Button
                startIcon={<ArrowBackIosIcon />}
                variant="outlined"
                color="default"
                onClick={handleBack}
                className={classes.backButton}
              >
                Back
              </Button>
              <Button
                variant="contained"
                color="primary"
                onClick={handleNextClick}
                className={classes.button}
                endIcon={
                  loading ? (
                    <CircularProgress size={20} />
                  ) : (
                    <ArrowForwardIosIcon />
                  )
                }
                disabled={loading || !areAllIngestionSectionsComplete()}
              >
                {loading ? "Saving..." : "Save & Next"}
              </Button>
            </div>
          )}
        </form>
        {readOnly && (
          <Divider
            style={{
              margin: "80px 00px 0px 00px",
              backgroundColor: "#707070",
              height: 1,
            }}
          />
        )}
      </div>
    </div>
  );
};

export default ShipmentConfigurations;
